"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.synerisMethods = exports.methodStyles = void 0;
const tslib_1 = require("tslib");
require("babel-polyfill");
exports.methodStyles = {
    Default: 0x00008000,
    ChangeObject: 0x00000002,
    SearchResult: 0x00000004,
    CreatesObject: 0x00000080,
    Invisible: 0x00000100,
    ForVersion: 0x00000200,
    DeleteObject: 0x00000400,
    ForOldVersion: 0x00000800,
    Async: 0x00010000,
    NotReverseRel: 0x00020000,
    DropMenu: 0x00080000,
    Disabled: 0x00100000,
    Report: 0x00400000,
    UseSelectedObjectAsContextInTree: 0x00800000,
    NeedsRefresh: 0x01000000,
    NeedsParentContext: 0x02000000,
};
const moment = require("moment");
const _ = require("underscore");
const $ = require("jquery");
const Utilities_1 = require("../../javascript/Utilities");
const Matrix_1 = require("../Matrix/Matrix");
require("../CategoryChooser/CategoryChooser");
require("../PropertyPage/PropertyPage");
const Base_1 = require("../../model/Base");
require("../Upload/Templates");
require("../Checklist/Checklist");
const MethodManager_1 = require("./MethodManager");
const QueryString_1 = require("../../javascript/QueryString");
const ChecklistControls_1 = require("../Checklist/ChecklistControls");
const Wopi_1 = require("../../javascript/ProdSys/Wopi");
const Instance_1 = require("../../model/Instance");
const MethodServerResponse_1 = require("../../model/MethodServerResponse");
// Implementation of Menuentries in javascript for basic functionality
// NOTE:
//   *  If imageUrl is not defined, webservice Icon/menuentry/[internalName]/16 will be used.
//      Fallback is a transparent icon if webservice finds no icon for the menuentry.
//   * If selCount is not defined, it defaults to 1
//   * If impl is not defined, nothing happens when the menu entry is clicked.
exports.synerisMethods = {
    // GUI methods have to be implemented here. Duplicate the desktop GUI method by adding the prefix "guimethods."
    // (e.g. menusearch --> guimethods.menusearch). Duplicate string values and icon.
    guimethods: {
        "docgraph": {
            impl(ids, parentId, relId, completedHandler, options) {
                if (ids && ids.length === 1) {
                    const url = "#/graph?id=" + ids[0];
                    if (options && options.newWindow)
                        window.open(url);
                    else
                        window.location.href = url;
                    if (completedHandler)
                        completedHandler(false);
                }
            }
        },
        "multidocnew": {
            impl(ids, parentId, relId, completedHandler) {
                window.location.href = "#/newDocMulti" + QueryString_1.QueryString.toQueryString({ parentId: parentId, relId: relId.toString() });
            }
        },
        "processmap": {
            impl(ids, parentId, relId, completedHandler, options) {
                if (ids && ids.length === 1) {
                    const url = "#/processmap?id=" + ids[0] + "&readonly=true";
                    if (options && options.newWindow)
                        window.open(url);
                    else
                        window.location.href = url;
                    if (completedHandler)
                        completedHandler(false);
                }
            }
        },
    },
    // adobeinte
    20: {
        // Redlining-Inhalt öffnen
        "105": {
            // common implementation for 20.105, cefunc.181 and cefunc.182
            _impl_internal(methodId, ids, parentId, relId, completedHandler) {
                const exportpath = methodId + "exportpath";
                const guid = Utilities_1.synUtil.getGUID();
                const dataobj = {
                    tempPathGUID: guid,
                    tempPathTarget: exportpath
                };
                const contentTempDownloadableUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownloadable");
                const contentTempDownloadUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownload");
                Utilities_1.synUtil.executeMethod({
                    method: methodId,
                    ids,
                    parentId,
                    relId,
                    done() {
                        Utilities_1.synUtil.getAJAXData({
                            url: contentTempDownloadableUrl + guid,
                            done(data) {
                                if (data.downloadable)
                                    $.fileDownload(contentTempDownloadUrl + guid + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken + "&forceAttachment=true");
                            }
                        });
                    },
                    additionalData: dataobj
                });
            },
            impl(ids, parentId, relId, completedHandler) {
                exports.synerisMethods[20]["105"]._impl_internal("20.105", ids, parentId, relId, completedHandler);
            }
        },
        // Redlining-Inhalt viewen
        "106": {
            impl(ids, parentId, relId, completedHandler) {
                const guid = Utilities_1.synUtil.getGUID();
                const dataobj = {
                    tempPathGUID: guid,
                    tempPathTarget: "20.106exportpath"
                };
                const contentTempDownloadableUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownloadable");
                const contentTempDownloadUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownload");
                Utilities_1.synUtil.executeMethod({
                    method: "20.106",
                    ids,
                    parentId,
                    relId,
                    done() {
                        Utilities_1.synUtil.getAJAXData({
                            url: contentTempDownloadableUrl + guid,
                            done(data) {
                                if (data.downloadable)
                                    $.fileDownload(contentTempDownloadUrl + guid + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken + "&forceAttachment=true");
                            }
                        });
                    },
                    additionalData: dataobj
                });
            }
        },
        // Redlining-Inhalt einchecken
        "107": {
            impl(ids, parentId, relId, completedHandler) {
                Utilities_1.synUtil.executeMethod({
                    method: "20.107",
                    ids,
                    parentId,
                    relId,
                    done() {
                        const windowData = Utilities_1.synUtil.uploadWindow({
                            action: "Checkin",
                            onAction(guids) {
                                const dataobj = {
                                    fileGUIDs: guids.join(";")
                                };
                                Utilities_1.synUtil.executeMethod({
                                    method: "20.107",
                                    ids,
                                    parentId,
                                    relId,
                                    done() {
                                        Utilities_1.synUtil.Notifications.menuSuccess("20.107");
                                        $("#" + windowData.windowID).data("kendoWindow").close();
                                    },
                                    cleanUp() {
                                        Utilities_1.synUtil.endAjaxProgress("#" + windowData.buttonID);
                                    },
                                    additionalData: dataobj
                                });
                            }
                        });
                    },
                    additionalData: { "20.107action": "config" }
                });
            }
        }
    },
    45: {
        "1": (require("./45/45_1")).default
    },
    41003: {
        "1": (require("./41003/41003_1")).default
    },
    // ceimpexp
    ceimpexp: {
        // Excel Report mit Template Marker
        "16": {
            impl(ids, parentId, relId, completedHandler) {
                const guid = Utilities_1.synUtil.getGUID();
                const dataobj = {
                    tempPathGUID: guid,
                    tempPathTarget: "ceimpexp16_xls_filename"
                };
                const contentTempDownloadableUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownloadable");
                const contentTempDownloadUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownload");
                Utilities_1.synUtil.executeMethod({
                    method: "ceimpexp.16",
                    ids,
                    parentId,
                    relId,
                    done() {
                        Utilities_1.synUtil.getAJAXData({
                            url: contentTempDownloadableUrl + guid,
                            done(data) {
                                if (data.downloadable)
                                    $.fileDownload(contentTempDownloadUrl + guid + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken);
                            }
                        });
                    },
                    additionalData: dataobj
                });
            }
        },
    },
    admfunc: {
        // Ändere Passwort
        "6": {
            impl(ids, parentId, relId) {
                const changePasswordMarkup = require("../../templates/ChangePassword.tmpl.html");
                const changePwdWSUrl = Utilities_1.synUtil.getWSUrl("ChangePwd");
                const generatePwdWSUrl = Utilities_1.synUtil.getWSUrl("GeneratePwd");
                const action = Utilities_1.synUtil.Strings.getValue("pasdlgcaption");
                const generatePWD = Utilities_1.synUtil.Strings.getValue("pasdlggeneratePWD");
                const windowData = Utilities_1.synUtil.popupWindow({
                    title: action,
                    width: 490,
                    height: 150,
                    modal: true
                });
                const data = {
                    synUtil: Utilities_1.synUtil,
                    windowID: "popup_" + windowData.guid,
                    oldPwdID: "oldPwd_" + windowData.guid,
                    newPwdID: "newPwd_" + windowData.guid,
                    newPwdConfirmID: "newPwdConfirm_" + windowData.guid,
                    buttonID: "button_" + windowData.guid,
                    buttonText: kendo.htmlEncode(action),
                    generatedPwdID: "generatedPwd_" + windowData.guid,
                    buttonID1: "button1_" + windowData.guid,
                    buttonText1: kendo.htmlEncode(generatePWD),
                    buttonCancelID: "buttonCancel_" + windowData.guid
                };
                // Create HTML from template
                const template = kendo.template(changePasswordMarkup);
                windowData.contentDiv.html(template(data));
                windowData.contentDiv.find(".k-textbox").keypress(function (e) {
                    if (e.which === 13) {
                        e.preventDefault();
                        $("#" + data.buttonID).trigger("click");
                    }
                });
                const windowid = data.windowID;
                $("#" + data.buttonCancelID).on('click', function () {
                    $("#" + windowid).data("kendoWindow").close();
                });
                $("#" + data.buttonID1).on('click', function () {
                    Utilities_1.synUtil.getAJAXData({
                        method: "POST",
                        url: generatePwdWSUrl,
                        done(msg) {
                            $("#" + data.generatedPwdID).val(msg);
                            $("#" + data.newPwdID).val(msg);
                            $("#" + data.newPwdConfirmID).val(msg);
                        },
                        fail(jqXHR, textStatus, errorThrown, url) {
                            $("#" + data.generatedPwdID).val("");
                            $("#" + data.newPwdID).val("");
                            $("#" + data.newPwdConfirmID).val("");
                            Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                        }
                    });
                });
                $("#" + data.buttonID).on('click', function () {
                    const oldpwd = $("#" + data.oldPwdID).val();
                    const newpwd = $("#" + data.newPwdID).val();
                    const newpwdconfirm = $("#" + data.newPwdConfirmID).val();
                    if (!oldpwd)
                        $.errorDialog({
                            ErrorDisplayMessage: Utilities_1.synUtil.Strings.getValue("pasdlgoldpasswordempty")
                        });
                    else if (!newpwd)
                        $.errorDialog({
                            ErrorDisplayMessage: Utilities_1.synUtil.Strings.getValue("pasdlgnewpasswordempty")
                        });
                    else if (!newpwdconfirm)
                        $.errorDialog({
                            ErrorDisplayMessage: Utilities_1.synUtil.Strings.getValue("pasdlgconfirmpasswordempty")
                        });
                    else if (newpwd !== newpwdconfirm)
                        $.errorDialog({
                            ErrorDisplayMessage: Utilities_1.synUtil.Strings.getValue("pasdlgnewpwdwrong")
                        });
                    else {
                        const pwdData = { oldPwd: oldpwd, newPwd: newpwd };
                        Utilities_1.synUtil.getAJAXData({
                            method: "POST",
                            url: changePwdWSUrl,
                            requestData: JSON.stringify(pwdData),
                            done(data) {
                                $("#" + windowid).data("kendoWindow").close();
                                Utilities_1.synUtil.Notifications.menuSuccess("pasdlgcaption");
                            }
                        });
                    }
                });
            }
        },
        "16": (require("./admfunc/admfunc_16")).default
    },
    cefunc: {
        // Eigenschaften
        "2": {
            selCount: 1,
            impl(ids, parentId, relId, completedHandler, options) {
                if (ids && ids.length === 1) {
                    const url = tdBasePath + "/#/properties?id=" + ids[0];
                    if (options && options.newWindow)
                        window.open(url);
                    else
                        window.location.href = url;
                    if (completedHandler)
                        completedHandler(false);
                }
            }
        },
        // Neuen Syneris Client starten
        "18": {
            selCount: 1,
            impl(ids, parentId, relId, completedHandler, options) {
                if (ids && ids.length === 1) {
                    if (completedHandler)
                        completedHandler(false);
                    window.open(tdBasePath + "/#/structure?root=" + ids[0]);
                }
            }
        },
        // Löschen
        "24": {
            impl(ids, parentId, relId, completedHandler) {
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("InstanceMultiple"),
                    requestData: { ids: ids.join(";"), properties: "name" },
                    done(data) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            const namesArray = [];
                            for (const prop in data) {
                                let instance = yield Instance_1.Instance.fromJSON(data[prop]);
                                namesArray.push(instance.name.value);
                            }
                            let msg = Utilities_1.synUtil.Strings.getValue("asksuredelete", "The following documents will be deleted: %sContinue?");
                            msg = Utilities_1.synUtil.convertFormatString(msg);
                            if (confirm(kendo.format(msg, "\n\n" + namesArray.join("\n") + "\n\n"))) {
                                const dataobj = {
                                    "cefunc.24forcedelete": true
                                };
                                Utilities_1.synUtil.executeMethod({
                                    method: "cefunc.24",
                                    ids,
                                    parentId,
                                    relId,
                                    done(dataJSON) {
                                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                            if (completedHandler) {
                                                let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                                completedHandler(true, data);
                                            }
                                        });
                                    },
                                    additionalData: dataobj
                                });
                            }
                            else if (completedHandler)
                                completedHandler(false, undefined);
                        });
                    }
                });
            }
        },
        // Verknüpfung entfernen
        "25": {
            impl(ids, parentId, relId, completedHandler) {
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("InstanceMultiple"),
                    requestData: { ids: ids.join(";"), properties: "name" },
                    done(data) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            const namesArray = [];
                            for (const prop in data) {
                                let instance = yield Instance_1.Instance.fromJSON(data[prop]);
                                namesArray.push(instance.name.value);
                            }
                            let msg = Utilities_1.synUtil.Strings.getValue("asksureremove", "Links to the following documents will be removed: %sContinue?");
                            msg = Utilities_1.synUtil.convertFormatString(msg);
                            if (confirm(kendo.format(msg, "\n\n" + namesArray.join("\n") + "\n\n"))) {
                                const dataobj = {
                                    "cefunc.25forceremove": true
                                };
                                Utilities_1.synUtil.executeMethod({
                                    method: "cefunc.25",
                                    ids,
                                    parentId,
                                    relId,
                                    done(dataJSON) {
                                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                            let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                            if (completedHandler)
                                                completedHandler(true, data);
                                        });
                                    },
                                    additionalData: dataobj
                                });
                            }
                        });
                    }
                });
            }
        },
        // Anzeigen
        "26": {
            selCount: 1,
            impl(ids, parentId, relId, completedHandler, options) {
                const p = require("../../javascript/ProdSys/ProdSys");
                p.ProdSysDispatcher.Action(ids, 10, options).then((actionResult) => {
                    if (!actionResult.handled) {
                        const opts = { id: actionResult.id, version: undefined, done: undefined };
                        if (options && options.version)
                            opts.version = options.version;
                        if (completedHandler)
                            opts.done = function () {
                                completedHandler(false, undefined);
                            };
                        Utilities_1.synUtil.viewInstance(opts);
                    }
                });
            }
        },
        // Checkout
        "28": (require("./cefunc/cefunc_28")).default,
        // Unlock ("Sperre aufheben")
        "31": {
            impl(ids, parentId, relId, completedHandler) {
                const UnlockDocuments = function (ids, parentId, relId, useSynerisWorkspace, completedHandler) {
                    if (useSynerisWorkspace) {
                        Utilities_1.synUtil.openWorkspace("synerisws" + ids[0].split("|")[0] + "://common/unlock/" + ids);
                        if (completedHandler)
                            completedHandler(true);
                    }
                    else {
                        Utilities_1.synUtil.executeMethod({
                            method: "cefunc.31",
                            ids,
                            parentId,
                            relId,
                            done(dataJSON) {
                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                    if (completedHandler) {
                                        let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                        completedHandler(true, data);
                                    }
                                });
                            }
                        });
                    }
                };
                // Check if wopi is enabled for user
                let userInfo = Utilities_1.synUtil.UserInfo.getUserInfo();
                if (Wopi_1.Wopi.IsUserEnabledForWopi(userInfo)) {
                    // Get all instances to unlock
                    Utilities_1.synUtil.getAJAXData({
                        method: "POST",
                        url: Utilities_1.synUtil.getWSUrl("InstanceMultiple"),
                        requestData: { ids: ids.join(";"), properties: "cgdocument.prodid", fetchContents: true },
                        done(data) {
                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                for (let instId in data) {
                                    let instanceJSON = data[instId];
                                    let instance = yield Instance_1.Instance.fromJSON(instanceJSON);
                                    // Check if wopi is enabled for prodsys
                                    if (Wopi_1.Wopi.IsProdSysEnabledForWopi(instance)) {
                                        // WOPI is used (single instance)
                                        // Remove wopi lock and unlock like without workspace
                                        let docId = instance.items["cgdocument.docid"].value.toString();
                                        Utilities_1.synUtil.getAJAXData({
                                            method: "POST",
                                            url: Utilities_1.synUtil.getWSUrl("RemoveLock") + docId + "-edit",
                                            done(data) {
                                                UnlockDocuments([instId], parentId, relId, false);
                                            }
                                        });
                                    }
                                    else {
                                        // WOPI is not used, behaviour like before (single instance)
                                        UnlockDocuments([instId], parentId, relId, Utilities_1.synUtil.useSynerisWorkspace);
                                    }
                                }
                                if (completedHandler)
                                    completedHandler(true);
                            });
                        }
                    });
                }
                else {
                    // WOPI is not used, behaviour like before (multiple instances)
                    UnlockDocuments(ids, parentId, relId, Utilities_1.synUtil.useSynerisWorkspace, completedHandler);
                }
            }
        },
        // Neue Version
        "42": {
            impl(ids, parentId, relId, completedHandler) {
                Utilities_1.synUtil.executeMethod({
                    method: "cefunc.42",
                    ids,
                    done(dataJSON) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            const data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                            let mandatoryComment = false;
                            let fieldLen = 128;
                            if (data.additionalInformation["cefunc.42fieldlen"]) {
                                const s = parseInt(data.additionalInformation["cefunc.42fieldlen"], 10);
                                if (!isNaN(s))
                                    fieldLen = s;
                            }
                            if (data.additionalInformation["cefunc.42mandatoryversioncomment"])
                                mandatoryComment = "Y" === data.additionalInformation["cefunc.42mandatoryversioncomment"];
                            const action = Utilities_1.synUtil.Strings.getValue("cefunc.42");
                            const windowData = Utilities_1.synUtil.popupWindow({
                                title: action,
                                width: 450,
                                height: 235,
                                modal: true
                            });
                            const windowid = "popup_" + windowData.guid;
                            const data2 = {
                                synUtil: Utilities_1.synUtil,
                                windowID: "popup_" + windowData.guid,
                                buttonID: "button_" + windowData.guid,
                                cancelButtonID: "cancelButton_" + windowData.guid,
                                textareaID: "textarea_" + windowData.guid,
                                buttonText: kendo.htmlEncode(action),
                                fieldText: Utilities_1.synUtil.Strings.getValue("cgdocument.vercomment.1"),
                                mandatoryComment
                            };
                            // Create HTML from template
                            require.ensure(["../../templates/VersionComment.less"], function (require) {
                                const versionCommentLess = require("../../templates/VersionComment.less");
                                const versionCommentMarkup = require("../../templates/VersionComment.tmpl.html");
                                const template = kendo.template(versionCommentMarkup);
                                windowData.contentDiv.html(template(data2));
                                $("#" + data2.textareaID)
                                    .attr("maxlength", fieldLen.toString())
                                    .focus();
                                if (mandatoryComment)
                                    $("#" + data2.textareaID).on("input propertychange", function () {
                                        if ($(this).val())
                                            Utilities_1.synUtil.toggleEnabledState($("#" + data2.buttonID), true);
                                        else
                                            Utilities_1.synUtil.toggleEnabledState($("#" + data2.buttonID), false);
                                    });
                                $("#" + data2.cancelButtonID).on('click', function () {
                                    $("#" + windowid).data("kendoWindow").close();
                                });
                                $("#" + data2.buttonID).on('click', function () {
                                    const dataObj = {
                                        "cefunc.42versioncomment": $("#" + data2.textareaID).val()
                                    };
                                    Utilities_1.synUtil.executeMethod({
                                        method: "cefunc.42",
                                        ids,
                                        parentId,
                                        relId,
                                        done(data3JSON) {
                                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                const data3 = yield MethodServerResponse_1.MethodServerResponse.fromJSON(data3JSON);
                                                $("#" + windowid).data("kendoWindow").close();
                                                if (completedHandler)
                                                    completedHandler(true, data3);
                                            });
                                        },
                                        additionalData: dataObj
                                    });
                                });
                            });
                        });
                    },
                    fail(jqXHR, textStatus, errorThrown, url) {
                        if (completedHandler)
                            completedHandler(false);
                        Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                    },
                    additionalData: { "cefunc.42action": "config" }
                });
            }
        },
        // Start Help
        "57": {
            selCount: -1,
            impl(ids, parentId, relId, completedHandler) {
                const actionKey = "cefunc.57action";
                const addlData = {};
                addlData[actionKey] = "config";
                Utilities_1.synUtil.executeMethod({
                    method: "cefunc.57",
                    additionalData: addlData,
                    ids,
                    parentId,
                    relId,
                    done(dataJSON) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                            if (data.additionalInformation["cefunc.57roothelpfolderdocid"])
                                window.open(tdBasePath + "#/structure?root=" + data.additionalInformation["cefunc.57roothelpfolderdocid"]);
                        });
                    }
                });
            },
        },
        // (Single)Checkin
        "62": {
            selCount: 1,
            impl(ids, parentId, relId, completedHandler) {
                if (Utilities_1.synUtil.useSynerisWorkspace) {
                    Utilities_1.synUtil.openWorkspace("synerisws" + ids[0].split("|")[0] + "://common/checkin/" + ids);
                    if (completedHandler)
                        completedHandler(false);
                }
                else {
                    const windowData = Utilities_1.synUtil.uploadWindow({
                        action: Utilities_1.synUtil.Strings.getValue("cefunc.62"),
                        onAction(guids) {
                            const dataobj = {
                                fileGUIDs: guids.join(";")
                            };
                            Utilities_1.synUtil.executeMethod({
                                method: "cefunc.62",
                                ids,
                                parentId,
                                relId,
                                done(dataJSON) {
                                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                        let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                        $("#" + windowData.windowID).data("kendoWindow").close();
                                        if (completedHandler)
                                            completedHandler(true, data);
                                    });
                                },
                                cleanUp() {
                                    Utilities_1.synUtil.endAjaxProgress("#" + windowData.buttonID);
                                },
                                additionalData: dataobj
                            });
                        }
                    });
                }
            }
        },
        // Inhalt hinzufügen/ersetzen
        "63": {
            // common implementation for cefunc.63, cefunc.108 and cefunc.109
            _impl_internal(methodId, ids, parentId, relId, completedHandler, checkContentForCategory) {
                const checkContent = checkContentForCategory || false;
                const actionKey = methodId + "action";
                const hasContentKey = methodId + "hascontent";
                const askKey = methodId + "ask";
                const addlData = {};
                addlData[actionKey] = "check";
                Utilities_1.synUtil.executeMethod({
                    method: methodId,
                    additionalData: addlData,
                    ids,
                    parentId,
                    relId,
                    done(dataJSON) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                            let cont = false;
                            if ("N" !== data.additionalInformation[hasContentKey])
                                cont = window.confirm(data.additionalInformation[askKey]);
                            else
                                cont = true;
                            if (cont) {
                                const windowData = Utilities_1.synUtil.uploadWindow({
                                    action: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue(methodId)),
                                    document: ids[0],
                                    onAction(guids) {
                                        Utilities_1.synUtil.executeMethod({
                                            method: methodId,
                                            additionalData: { fileGUIDs: guids.join(";") },
                                            ids,
                                            parentId,
                                            relId,
                                            done(replaceDataJSON) {
                                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                    let replaceData = yield MethodServerResponse_1.MethodServerResponse.fromJSON(replaceDataJSON);
                                                    $("#" + windowData.windowID).data("kendoWindow").close();
                                                    if (completedHandler)
                                                        completedHandler(true, replaceData);
                                                });
                                            },
                                            cleanUp() {
                                                Utilities_1.synUtil.endAjaxProgress("#" + windowData.buttonID);
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            },
            impl(ids, parentId, relId, completedHandler) {
                exports.synerisMethods.cefunc["63"]._impl_internal("cefunc.63", ids, parentId, relId, completedHandler, true);
            }
        },
        // Inhalt löschen
        "65": {
            impl(ids, parentId, relId, completedHandler) {
                if (confirm(Utilities_1.synUtil.Strings.getValue("askreallydelnormalcontent"))) {
                    const dataobj = {
                        forcedelete: true
                    };
                    Utilities_1.synUtil.executeMethod({
                        method: "cefunc.65",
                        ids,
                        parentId,
                        relId,
                        done(dataJSON) {
                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                if (completedHandler)
                                    completedHandler(true, data);
                            });
                        },
                        additionalData: dataobj
                    });
                }
            }
        },
        // Attach Signed Version
        "101": {
            impl(ids, parentId, relId, completedHandler) {
                Utilities_1.synUtil.executeMethod({
                    method: "cefunc.101",
                    ids,
                    done(dataJSON) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                            let mandatoryComment = false;
                            let fieldLen = 128;
                            if (data.additionalInformation["cefunc.101fieldlen"]) {
                                const s = parseInt(data.additionalInformation["cefunc.101fieldlen"], 10);
                                if (!isNaN(s))
                                    fieldLen = s;
                            }
                            if (data.additionalInformation["cefunc.101mandatoryversioncomment"])
                                mandatoryComment = "Y" === data.additionalInformation["cefunc.101mandatoryversioncomment"];
                            // FileDialog
                            const windowData = Utilities_1.synUtil.uploadWindow({
                                action: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("cefunc.101")),
                                document: ids[0],
                                onAction(guids) {
                                    const action = Utilities_1.synUtil.Strings.getValue("cefunc.101");
                                    const windowDataTemp = Utilities_1.synUtil.popupWindow({
                                        title: action,
                                        width: 450,
                                        height: 235,
                                        modal: true
                                    });
                                    const windowid = "popup_" + windowDataTemp.guid;
                                    const data = {
                                        synUtil: Utilities_1.synUtil,
                                        windowID: "popup_" + windowDataTemp.guid,
                                        buttonID: "button_" + windowDataTemp.guid,
                                        cancelButtonID: "cancelButton_" + windowDataTemp.guid,
                                        textareaID: "textarea_" + windowDataTemp.guid,
                                        buttonText: kendo.htmlEncode(action),
                                        fieldText: Utilities_1.synUtil.Strings.getValue("cgdocument.vercomment.1"),
                                        mandatoryComment
                                    };
                                    // Create HTML from template
                                    require.ensure(["../../templates/VersionComment.less"], (require) => {
                                        const versionCommentLess = require("../../templates/VersionComment.less");
                                        const versionCommentMarkup = require("../../templates/VersionComment.tmpl.html");
                                        const template = kendo.template(versionCommentMarkup);
                                        windowDataTemp.contentDiv.html(template(data));
                                        $("#" + data.textareaID)
                                            .attr("maxlength", fieldLen.toString())
                                            .focus();
                                        if (mandatoryComment)
                                            $("#" + data.textareaID).on("input propertychange", function () {
                                                if ($(this).val())
                                                    Utilities_1.synUtil.toggleEnabledState($("#" + data.buttonID), true);
                                                else
                                                    Utilities_1.synUtil.toggleEnabledState($("#" + data.buttonID), false);
                                            });
                                        $("#" + data.cancelButtonID).on('click', function () {
                                            $("#" + windowid).data("kendoWindow").close();
                                        });
                                        $("#" + data.buttonID).on('click', function () {
                                            const dataObj = {
                                                "cefunc.101versioncomment": $("#" + data.textareaID).val()
                                            };
                                            Utilities_1.synUtil.executeMethod({
                                                method: "cefunc.101",
                                                ids,
                                                parentId,
                                                relId,
                                                done(data2) {
                                                    completedHandler(true, data2);
                                                },
                                                additionalData: { "cefunc.101versioncomment": dataObj["cefunc.101versioncomment"], fileGUIDs: guids.join(";") },
                                                cleanUp() {
                                                    $("#" + windowid).data("kendoWindow").close();
                                                    Utilities_1.synUtil.endAjaxProgress("#" + windowData.buttonID);
                                                }
                                            });
                                        });
                                        $("#" + windowData.windowID).data("kendoWindow").close();
                                    });
                                }
                            });
                        });
                    },
                    fail(jqXHR, textStatus, errorThrown, url) {
                        completedHandler(false);
                        Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                    },
                    additionalData: { "cefunc.101action": "config" }
                });
            }
        },
        // Viewing-Inhalt hinzufügen/ersetzen
        "108": {
            impl(ids, parentId, relId, completedHandler) {
                exports.synerisMethods.cefunc["63"]._impl_internal("cefunc.108", ids, parentId, relId, completedHandler, false);
            }
        },
        // Plot-Inhalt hinzufügen/ersetzen
        "109": {
            impl(ids, parentId, relId, completedHandler) {
                exports.synerisMethods.cefunc["63"]._impl_internal("cefunc.109", ids, parentId, relId, completedHandler, false);
            }
        },
        // Neu mit Vorlage
        "111": {
            impl(ids, parentId, relId, useInitialFiles) {
                window.location.href = "#/newDoc" + QueryString_1.QueryString.toQueryString({ parentId: parentId, relId: relId.toString(), initialFiles: useInitialFiles === true ? "true" : "false" });
            }
        },
        // Copy with content
        "121": {
            impl(ids, parentId, relId, completedHandler) {
                require.ensure(["../../templates/cefunc_121.less"], (require) => {
                    const cefunc_121_less = require("../../templates/cefunc_121.less");
                    const markup = require("../../templates/cefunc_121.tmpl.html");
                    if (ids[0] === parentId) {
                        parentId = undefined;
                        relId = undefined;
                    }
                    const sourceTypeId = parseInt(ids[0].split("|")[2], 10);
                    const sourceDocId = ids[0].split("|")[1];
                    // Create Window
                    const windowData = Utilities_1.synUtil.popupWindow({
                        title: Utilities_1.synUtil.Strings.getValue("cefunc.121"),
                        actions: ["Maximize", "Close"],
                        width: 1040,
                        height: 600,
                        resizable: true,
                        modal: true,
                        synDesktopAware: false
                    });
                    // Initialize contents
                    const configData = {
                        synUtil: Utilities_1.synUtil,
                        windowID: "popup_" + windowData.guid,
                        contentCheckBoxId: "cbContent_" + windowData.guid,
                        propPageId: "propPage_" + windowData.guid,
                        okButtonId: "okButton_" + windowData.guid,
                        okCloseButtonId: "okCloseButton_" + windowData.guid,
                        cancelButtonId: "cancelButton_" + windowData.guid,
                    };
                    // Create HTML from template
                    const template = kendo.template(markup);
                    windowData.contentDiv.html(template(configData));
                    // category chooser + proppage
                    const propPagePane = $("#" + configData.propPageId);
                    propPagePane
                        .on("instanceChanged", function (evt, curInst) {
                        let copyContent = "Y";
                        if ($("#" + configData.contentCheckBoxId).prop('checked') === false)
                            copyContent = "N";
                        const dataObj = {
                            "cefunc_121_target_typeid": curInst.items["cgdocument.typeid"].value,
                            "cefunc_121_copy_content": copyContent
                        };
                        Utilities_1.synUtil.executeMethod({
                            method: "cefunc.121",
                            ids,
                            additionalData: dataObj,
                            done(dataJSON) {
                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                    let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                    const modifiedInstance = data.modifications.new.instances[0];
                                    let instanceDiff = modifiedInstance.clone();
                                    $.each(modifiedInstance.items, function (idx, field) {
                                        if ((curInst.items[field.name]) && (curInst.items[field.name].value === field.value))
                                            instanceDiff.removeField(field.name);
                                    });
                                    propPagePane.synPropertyPage("changeInstance", instanceDiff);
                                });
                            },
                        });
                    })
                        .on("endInit", function () {
                        propPagePane.synPropertyPage("setTemplate", {
                            mode: Base_1.PropertyPageMode.New,
                            parentId,
                            parentRelId: relId,
                            typeId: sourceTypeId
                        });
                    })
                        .synPropertyPage({
                        layout: Utilities_1.synUtil.clientDeviceClass === "phone" || Utilities_1.synUtil.clientDeviceClass === "tablet" ? "table" : "absolute",
                        renderMode: Utilities_1.synUtil.clientDeviceClass
                    });
                    const categoryChooser = $(".CategoryChooser");
                    categoryChooser
                        .on("initSuccess", function (e) {
                        categoryChooser.synCategoryChooser("setSelectedCategory", sourceTypeId, false, false);
                    })
                        .on("categorySelectedManually", function (event, categorySelected) {
                        propPagePane.synPropertyPage("setTemplate", {
                            mode: Base_1.PropertyPageMode.New,
                            parentId,
                            parentRelId: relId,
                            typeId: categorySelected.id
                        });
                    })
                        .synCategoryChooser({
                        showIcons: true,
                        showTreeButton: true,
                        showDependsCheckbox: false,
                        parentId,
                        parentRelId: relId
                    });
                    // save event
                    const saveDocument = function (openNewDocumentInTab) {
                        Utilities_1.synUtil.beginAjaxProgress("#" + configData.okButtonId);
                        Utilities_1.synUtil.beginAjaxProgress("#" + configData.okCloseButtonId);
                        const inst = propPagePane.synPropertyPage("getInstance");
                        let copyContent = "Y";
                        if ($("#" + configData.contentCheckBoxId).prop('checked') === false) {
                            Utilities_1.synUtil.getInstance(ids, (instance) => {
                                instance.items["ceproddef.name"].value = "";
                                propPagePane.synPropertyPage("changeInstance", instance);
                            });
                            copyContent = "N";
                        }
                        const dataObj = {
                            "cefunc_121_source_docid": sourceDocId,
                            "cefunc_121_copy_content": copyContent
                        };
                        Utilities_1.synUtil.executeMethod({
                            method: "cefunc.121",
                            instanceData: JSON.stringify([inst.toJSON()]),
                            parentId,
                            relId,
                            additionalData: dataObj,
                            done(dataNewJSON) {
                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                    let dataNew = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataNewJSON);
                                    $("#" + configData.windowID).data("kendoWindow").close();
                                    if (openNewDocumentInTab === true) {
                                        const newInstance = dataNew.modifications.new.instances[0];
                                        window.open("#/properties?id=" + newInstance.id.value, "_blank");
                                    }
                                    if (completedHandler)
                                        completedHandler(true, dataNew);
                                });
                            },
                            cleanUp() {
                                Utilities_1.synUtil.endAjaxProgress("#" + configData.okButtonId);
                                Utilities_1.synUtil.endAjaxProgress("#" + configData.okCloseButtonId);
                            },
                            fail(error) {
                                Utilities_1.synUtil.Notifications.error(error["responseJSON"]["ErrorDisplayMessage"]);
                            }
                        });
                    };
                    // Save and close button click event
                    $("#" + configData.okCloseButtonId).on('click', function () {
                        saveDocument(false);
                    });
                    // save button click event
                    $("#" + configData.okButtonId).on('click', function () {
                        saveDocument(true);
                    });
                    // Cancel button click event
                    $("#" + configData.cancelButtonId).on('click', function () {
                        $("#" + configData.windowID).data("kendoWindow").close();
                    });
                });
            }
        },
        // URL öffnen
        "144": {
            impl(ids, parentId, relId) {
                if (ids.length > 0) {
                    const fieldName = Utilities_1.synUtil.Configs.getValueMandatory("openurlurlfieldname", parseInt(ids[0].split("|")[2], 10));
                    Utilities_1.synUtil.getInstance(ids[0], function (instance) {
                        let url = instance.items[fieldName].valueToString();
                        const patternURI = new RegExp(/\w+:(\/?\/?)[^\s]/);
                        const patternURL = new RegExp('^(https?:\\/\\/)?' + // protocol
                            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
                        if (patternURI.test(url) && !url.includes(",") && !url.includes(";") && !url.includes("!")) // "," , ";" and "!" are temporary fixes
                            window.open(url, "_blank");
                        else if (patternURL.test(url)) {
                            const prefixWWW = 'www.';
                            const prefixS = 'https://';
                            const prefix = 'http://';
                            if (url.substr(0, prefixS.length) !== prefixS || url.substr(0, prefix.length) !== prefix) {
                                if (url.substr(0, prefixWWW.length) !== prefixWWW)
                                    url = prefixWWW + url;
                                url = prefixS + url;
                            }
                            window.open(url, "_blank");
                        }
                        else
                            Utilities_1.synUtil.Notifications.error(kendo.format(Utilities_1.synUtil.Strings.getValue("ERROR_200013|2"), url));
                    });
                }
            }
        },
        // Kopieren
        "159": {
            impl(ids, parentId, relId) {
                const clipboard = $("#Clipboard");
                if (clipboard)
                    clipboard.synClipboard("copy", ids);
            }
        },
        // Ausschneiden
        "160": {
            impl(ids, parentId, relId, completedHandler) {
                const clipboard = $("#Clipboard");
                if (clipboard) {
                    const completed = function (bool, data) {
                        clipboard.synClipboard("copy", ids);
                        completedHandler(bool, data);
                    };
                    exports.synerisMethods.cefunc["25"].impl(ids, parentId, relId, completed);
                }
            }
        },
        // Einfügen
        "161": {
            impl(ids, parentId, relId) {
                const clipboard = $("#Clipboard");
                if (clipboard) {
                    if (clipboard.synClipboard("itemCount") > 0) {
                        clipboard.synClipboard("paste", undefined, parentId, relId);
                    }
                    else {
                        Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("clipboardemtpy"));
                    }
                }
            }
        },
        // Attach Signed File
        "167": {
            impl(ids, parentId, relId, completedHandler) {
                const windowData = Utilities_1.synUtil.uploadWindow({
                    action: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("cefunc.167")),
                    document: ids[0],
                    onAction(guids) {
                        Utilities_1.synUtil.executeMethod({
                            method: "cefunc.167",
                            additionalData: { fileGUIDs: guids.join(";") },
                            ids,
                            parentId,
                            relId,
                            done(dataJSON) {
                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                    let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                    $("#" + windowData.windowID).data("kendoWindow").close();
                                    if (completedHandler)
                                        completedHandler(true, data);
                                });
                            },
                            cleanUp() {
                                Utilities_1.synUtil.endAjaxProgress("#" + windowData.buttonID);
                            }
                        });
                    }
                });
            }
        },
        // VCF generieren
        "181": {
            impl(ids, parentId, relId, completedHandler) {
                exports.synerisMethods[20]["105"]._impl_internal("cefunc.181", ids, parentId, relId, completedHandler);
            }
        },
        // ICS generieren
        "182": {
            impl(ids, parentId, relId, completedHandler) {
                exports.synerisMethods[20]["105"]._impl_internal("cefunc.182", ids, parentId, relId, completedHandler);
            }
        },
        "184": {
            impl(ids, parentId, relId, completedHandler, options) {
                let id = ids[0];
                if (options.version && !options.version.verCur)
                    id += "|" + options.version.version;
                Utilities_1.synUtil.executeMethod({
                    method: "cefunc.184",
                    ids: [id],
                    parentId,
                    relId,
                    additionalData: { "cefunc.184action": "config" },
                    done(dataJSON) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                            if (data.additionalInformation["cefunc.184availablecontenttypes"]) {
                                const contents = JSON.parse(data.additionalInformation["cefunc.184availablecontenttypes"]);
                                // Different implementations for desktop and web
                                const viewCore = function (id, conType, windowId, completedHandler) {
                                    if (typeof window.synDesktopApp !== "undefined") {
                                        window.synDesktopApp.set_resultValue(encodeURIComponent(conType.toString()));
                                        window.synDesktopApp.endDialog("1");
                                    }
                                    else {
                                        Utilities_1.synUtil.viewInstance({ id, contentType: conType, version: options.version });
                                        if (windowId)
                                            $("#" + windowId).data("kendoWindow").close();
                                        completedHandler(false);
                                    }
                                };
                                if (contents.length === 0)
                                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("docnocontent"));
                                else if (contents.length === 1)
                                    viewCore(ids[0], contents[0].id, undefined, completedHandler);
                                else {
                                    require.ensure(["../../templates/cefunc_184.less"], (require) => {
                                        const cefunc_184_less = require("../../templates/cefunc_184.less");
                                        const markup = require("../../templates/cefunc_184.tmpl.html");
                                        const listItemMarkup = require("../../templates/cefunc_184_listItem.tmpl.html");
                                        const windowData = Utilities_1.synUtil.popupWindow({
                                            title: Utilities_1.synUtil.Strings.getValue("cefunc.184"),
                                            width: 600,
                                            height: 400,
                                            modal: true,
                                            synDesktopAware: true
                                        });
                                        const configData = {
                                            synUtil: Utilities_1.synUtil,
                                            splitterId: "splitterId_" + windowData.guid,
                                            contentListId: "contentListId_" + windowData.guid,
                                            cancelButtonId: "cancelButtonId_" + windowData.guid,
                                            okButtonId: "okButtonId_" + windowData.guid,
                                            windowID: windowData.windowID
                                        };
                                        // Create HTML from template
                                        const template = kendo.template(markup);
                                        windowData.contentDiv.html(template(configData));
                                        // Vertical splitter
                                        $("#" + configData.splitterId)
                                            .kendoSplitter({
                                            orientation: "vertical",
                                            panes: [{}, { size: "40px" }]
                                        });
                                        // Hide vertical splitbars
                                        $("#" + configData.splitterId).children(".k-splitbar-vertical").css("display", "none");
                                        contents.sort(function (a, b) {
                                            return a.id < b.id ? -1 : (a.id === b.id ? 0 : 1);
                                        });
                                        // Get Strings to avoid calling synUtil in cefunc_184_listItem.tmpl.html
                                        contents.forEach(function (element) {
                                            element["cgcontentFilesize1"] = Utilities_1.synUtil.Strings.getValue("cgcontent.filesize.1");
                                            element["cgcontentConid1"] = Utilities_1.synUtil.Strings.getValue("cgcontent.conid.1");
                                            element["cgcontentLastchangedate1"] = Utilities_1.synUtil.Strings.getValue("cgcontent.lastchangedate.1");
                                            element["stringLastChangeDate"] = kendo.toString(Utilities_1.synUtil.jsonToDateTime(element["lastChangeDate"]), "G");
                                            element["cgcontentLastchangeby1"] = Utilities_1.synUtil.Strings.getValue("cgcontent.lastchangeby.1");
                                            element["cgcontentCreatedate1"] = Utilities_1.synUtil.Strings.getValue("cgcontent.createdate.1");
                                            element["stringCreateDate"] = kendo.toString(Utilities_1.synUtil.jsonToDateTime(element["createDate"]), "G");
                                            element["cgcontentCreateby1"] = Utilities_1.synUtil.Strings.getValue("cgcontent.createby.1");
                                        });
                                        // Listview
                                        const listView = $("#" + configData.contentListId)
                                            .kendoListView({
                                            dataSource: contents,
                                            template: listItemMarkup,
                                            selectable: "single",
                                            change(e) {
                                                $("#" + configData.okButtonId).removeAttr("disabled");
                                            }
                                        }).data("kendoListView");
                                        listView.select(listView.element.find(".contentType").first());
                                        // Cancel button click event
                                        $("#" + configData.cancelButtonId).on('click', function () {
                                            if (typeof window.synDesktopApp !== "undefined")
                                                window.synDesktopApp.endDialog("0");
                                            else
                                                $("#" + configData.windowID).data("kendoWindow").close();
                                        });
                                        // OK button click event
                                        $("#" + configData.okButtonId).on('click', function () {
                                            const selectedConType = listView.dataItem(listView.select());
                                            viewCore(ids[0], selectedConType.id, configData.windowID, completedHandler);
                                        });
                                    });
                                }
                            }
                        });
                    }
                });
            }
        },
        // Set state/def.values
        "189": {
            impl(ids, parentId, relId, completedHandler) {
                Utilities_1.synUtil.beginAjaxProgress();
                Utilities_1.synUtil.executeMethod({
                    method: "cefunc.189",
                    ids,
                    parentId,
                    relId,
                    additionalData: {
                        "cefunc.189action": "config",
                        "cefunc.189selectedids": ids.join(";")
                    },
                    done(dataJSON) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                            require.ensure(["../../templates/cefunc_189.less"], (require) => {
                                const cefunc_189_less = require("../../templates/cefunc_189.less");
                                const markup = require("../../templates/cefunc_189.tmpl.html");
                                // Create Window
                                const windowData = Utilities_1.synUtil.popupWindow({
                                    title: Utilities_1.synUtil.Strings.getValue("cefunc.189"),
                                    actions: ["Maximize", "Close"],
                                    width: 800,
                                    height: 600,
                                    resizable: true,
                                    modal: true,
                                    synDesktopAware: true
                                });
                                // Initialize contents
                                const configData = {
                                    synUtil: Utilities_1.synUtil,
                                    windowID: "popup_" + windowData.guid,
                                    propPageId: "propPage_" + windowData.guid,
                                    okButtonId: "okButton_" + windowData.guid,
                                    cancelButtonId: "cancelButton_" + windowData.guid,
                                };
                                // Create HTML from template
                                const template = kendo.template(markup);
                                windowData.contentDiv.html(template(configData));
                                const propPagePane = $("#" + configData.propPageId);
                                const setColors = function () {
                                    const ctrls = propPagePane.data("synPropertyPage").controls;
                                    $.each(ctrls.allControls, function (idx, ctrl) {
                                        if (ctrl.type !== "CheckBoxInfo") {
                                            const $input = ctrl.getInputControl();
                                            if ($input.attr("placeholder")) {
                                                if ($input.val())
                                                    $input.removeClass("keepValue").removeClass("emptyValue");
                                                else if (!$input.hasClass("emptyValue"))
                                                    $input.addClass("keepValue");
                                            }
                                        }
                                    });
                                    const stateComboJQ = $("#stateCombo_" + windowData.guid);
                                    if (stateComboJQ.length) {
                                        const combo = stateComboJQ.data("kendoComboBox");
                                        const item = combo.dataItem(combo.select());
                                        if (item && item.id)
                                            combo.input.removeClass("keepValue");
                                        else
                                            combo.input.addClass("keepValue");
                                    }
                                };
                                const setColorForControl = function (control, hasValue) {
                                    if (control && control.type !== "CheckBoxInfo") {
                                        const inputControl = control.getInputControl();
                                        if (hasValue)
                                            inputControl.removeClass("keepValue").removeClass("emptyValue");
                                        else if (!inputControl.hasClass("keepValue") && !inputControl.hasClass("emptyValue"))
                                            inputControl.addClass("keepValue");
                                    }
                                };
                                const wireFocusHandler = function (c, fieldName) {
                                    const ctrls = propPagePane.data("synPropertyPage").controls;
                                    const ctrl = c.getInputControl ? c.getInputControl() : c;
                                    ctrl.focus(function () {
                                        clearTimeout(propPagePane.data("btnRemoveTimeoutId"));
                                        propPagePane.removeData("btnRemoveTimeoutId");
                                        const $this = $(this);
                                        const outer = $this.hasClass("ppTextBox") ? $this : $this.closest(".k-widget");
                                        const controlContainer = outer.parent();
                                        const left = parseInt(outer.css("left").replace(/px$/, ""), 10);
                                        const top = parseInt(outer.css("top").replace(/px$/, ""), 10);
                                        const marginTop = outer.css("margin-top");
                                        const marginBottom = outer.css("margin-bottom");
                                        controlContainer.find("button.btnEmptyValue").remove();
                                        const btn = $("<button type='button' class='btn btn-default btnEmptyValue'><i class='fa' /></button>")
                                            .css({
                                            height: outer.height() + "px",
                                            left: (left + outer.outerWidth()) + "px",
                                            top: top + "px",
                                            marginTop,
                                            marginBottom
                                        })
                                            .mousedown(function () {
                                            clearTimeout(propPagePane.data("btnRemoveTimeoutId"));
                                            propPagePane.data("btnRemoveTimeoutId", "ignore");
                                        })
                                            .on('click', function () {
                                            clearTimeout(propPagePane.data("btnRemoveTimeoutId"));
                                            propPagePane.removeData("btnRemoveTimeoutId");
                                            // FT Combo will be recreated with setValue(), so
                                            // we have to re-fetch DOM element here
                                            let inputElem = $();
                                            let control;
                                            if ($this.hasClass("clientSide_stateCombo")) {
                                                inputElem = $this;
                                                $("#stateCombo_" + windowData.guid).data("kendoComboBox").select(0);
                                            }
                                            else {
                                                const outerCur = $this.hasClass("ppTextBox") ? $this : $this.closest(".k-widget");
                                                let controlItemId = $this.attr("id");
                                                if ($this.hasClass("ppFTCombo"))
                                                    controlItemId = outerCur.children("select").attr("id");
                                                else if ($this.hasClass("ppNumericTextBox"))
                                                    controlItemId = outerCur.closest(".k-widget").find("input.k-input").not(".k-formatted-value").attr("id");
                                                const controlItem = $("#" + controlItemId);
                                                control = controlItem.data("control");
                                                inputElem = control.getInputControl();
                                                if (control.type === "FTComboBoxInfo") {
                                                    if (control.getValue()) {
                                                        control.setValue({ id: "", value: "" });
                                                        control.controlFactory.setWorkingValue(control.field.presentedField, undefined);
                                                        control.notifyDependentControls();
                                                        inputElem = control.getInputControl();
                                                    }
                                                }
                                                else
                                                    control.setValue(control.field.multiValue ? [] : undefined);
                                            }
                                            const togglePlaceHolderState = function (inp, bn) {
                                                if (inp.hasClass("keepValue")) {
                                                    if (bn)
                                                        bn.removeClass("removeValue").addClass("resetValue")
                                                            .children("i").removeClass("fa-eraser").addClass("fa-thumb-tack");
                                                    inp.attr("placeholder", Utilities_1.synUtil.Strings.getValue("synempty").toUpperCase());
                                                    inp.removeClass("keepValue").addClass("emptyValue");
                                                }
                                                else {
                                                    if (bn)
                                                        bn.removeClass("resetValue").addClass("removeValue")
                                                            .children("i").removeClass("fa-thumb-tack").addClass("fa-eraser");
                                                    inp.attr("placeholder", Utilities_1.synUtil.Strings.getValue("synkeep").toUpperCase());
                                                    inp.removeClass("emptyValue").addClass("keepValue");
                                                }
                                            };
                                            togglePlaceHolderState(inputElem, btn);
                                            if (control) {
                                                if (control.field.isFTField) {
                                                    $.each(ctrls.controlsByPresentedFieldName[control.field.presentedField], function (idx, depColl) {
                                                        if (depColl.Input && depColl.Input.field.fieldName !== control.field.fieldName)
                                                            togglePlaceHolderState(depColl.Input.getInputControl(), undefined);
                                                    });
                                                }
                                            }
                                        })
                                            .appendTo(controlContainer);
                                        if (fieldName !== "cestatedef.name") {
                                            // Collision detect for any (method-/mv-)button that shares the
                                            // presented field. If collision, move behind button.
                                            const field = ctrls.controlsByFieldName[fieldName].Input.field;
                                            const controlsToCheck = field.isFTField ?
                                                ctrls.controlsByPresentedFieldName[field.presentedField]
                                                : [ctrls.controlsByFieldName[fieldName]];
                                            $.each(controlsToCheck, function (idx, cur) {
                                                if (cur.Button) {
                                                    const buttonDOM = cur.Button.getDOMControl();
                                                    const el1 = btn[0];
                                                    const el2 = buttonDOM[0];
                                                    // Collision check: If this new button hides MV- or methodbutton,
                                                    // place it next to that button instead.
                                                    const offsetBottom1 = el1.offsetTop + el1.offsetHeight;
                                                    const offsetRight1 = el1.offsetLeft + el1.offsetWidth;
                                                    const offsetBottom2 = el2.offsetTop + el2.offsetHeight;
                                                    const offsetRight2 = el2.offsetLeft + el2.offsetWidth;
                                                    if (!((offsetBottom1 < el2.offsetTop) || (el1.offsetTop > offsetBottom2) ||
                                                        (offsetRight1 < el2.offsetLeft) || (el1.offsetLeft > offsetRight2))) {
                                                        const leftBtn = parseInt(buttonDOM.css("left").replace(/px$/, ""), 10);
                                                        const topBtn = parseInt(buttonDOM.css("top").replace(/px$/, ""), 10);
                                                        const marginTopBtn = buttonDOM.css("margin-top");
                                                        const marginBottomBtn = buttonDOM.css("margin-bottom");
                                                        btn.css({
                                                            height: buttonDOM.height() + "px",
                                                            left: (leftBtn + buttonDOM.outerWidth()) + "px",
                                                            top: topBtn + "px",
                                                            marginTop: marginTopBtn,
                                                            marginBottom: marginBottomBtn
                                                        });
                                                        return false;
                                                    }
                                                }
                                            });
                                        }
                                        if ($this.hasClass("emptyValue")) {
                                            btn.addClass("resetValue");
                                            btn.children("i").addClass("fa-thumb-tack");
                                        }
                                        else {
                                            btn.addClass("removeValue");
                                            btn.children("i").addClass("fa-eraser");
                                        }
                                    })
                                        .blur(function () {
                                        if ("ignore" === propPagePane.data("btnRemoveTimeoutId"))
                                            propPagePane.removeData("btnRemoveTimeoutId");
                                        else if ($(this).hasClass("k-formatted.value")) {
                                            const timeoutId = setTimeout(function () {
                                                propPagePane.removeData("btnRemoveTimeoutId")
                                                    .find("button.btnEmptyValue").remove();
                                            }, 150);
                                            propPagePane.data("btnRemoveTimeoutId", timeoutId);
                                        }
                                    });
                                };
                                propPagePane
                                    .on("controlsInitialized", function () {
                                    propPagePane.on('click', function (e) {
                                        if (e.target) {
                                            const tgt = $(e.target);
                                            if (tgt.is(propPagePane.children(".ppContainer"))
                                                || tgt.is("rect") || tgt.is("path") || tgt.parent().hasClass("ppStatic")) {
                                                propPagePane.find("button.btnEmptyValue").remove();
                                            }
                                        }
                                    });
                                    const ctrls = propPagePane.data("synPropertyPage").controls;
                                    // Make all fields non-mandatory
                                    $.each(ctrls.allControls, function (idx, ctrl) {
                                        if (ctrl.field)
                                            ctrl.setMandatory(false);
                                    });
                                    for (const prop in ctrls.controlsByFieldName) {
                                        const coll = ctrls.controlsByFieldName[prop];
                                        if (coll.Input) {
                                            // Increase transparency for all readonly fields (Input and Static)
                                            if (coll.Input.readonly && !coll.Button) {
                                                if (coll.Input.type === "NumericTextBoxInfo")
                                                    $("#" + coll.Input.id).data("kendoNumericTextBox").enable(false);
                                                coll.Input.getDOMControl().css("opacity", "0.25");
                                                if (coll.Static)
                                                    coll.Static.getDOMControl().css("opacity", "0.25");
                                            }
                                            else if (coll.Input && coll.Input.field && coll.Input.type !== "CheckBoxControl")
                                                wireFocusHandler(coll.Input, coll.Input.field.fieldName);
                                            // Set placeholders for datecontrols, textboxes and ft combos
                                            if (coll.Input.type !== "CheckBoxInfo")
                                                coll.Input.getInputControl().attr("placeholder", Utilities_1.synUtil.Strings.getValue("synkeep").toUpperCase());
                                        }
                                    }
                                    setColors();
                                    // Remove all stateid controls
                                    if (ctrls.controlsByPresentedFieldName.hasOwnProperty("cgdocument.stateid")) {
                                        let stateComboAdded = false;
                                        $.each(ctrls.controlsByPresentedFieldName["cgdocument.stateid"], function (idx, ctrl) {
                                            if (ctrl.Input) {
                                                if (data.additionalInformation["cefunc.189followstates"]) {
                                                    if (!stateComboAdded) {
                                                        // Create new clientside combobox
                                                        const ddlNew = $("<input />")
                                                            .attr("id", "stateCombo_" + windowData.guid)
                                                            .addClass("clientSide_stateCombo")
                                                            .css({
                                                            "width": ctrl.Input.width + "px",
                                                            "height": ctrl.Input.height + "px",
                                                        })
                                                            .insertAfter(ctrl.Input.getDOMControl());
                                                        // Initialize with valid follow states
                                                        const tmp = data.additionalInformation["cefunc.189followstates"].split(";");
                                                        const states = $.map(tmp, function (idAndState) {
                                                            const idxEq = idAndState.indexOf("=");
                                                            return {
                                                                id: idAndState.substring(0, idxEq),
                                                                name: idAndState.substring(idxEq + 1)
                                                            };
                                                        });
                                                        states.unshift({ id: undefined, name: "" });
                                                        const combo = ddlNew.kendoComboBox({
                                                            dataSource: states,
                                                            dataTextField: "name",
                                                            dataValueField: "id",
                                                            change(e) {
                                                                if (this.value())
                                                                    this.input.removeClass("keepValue").removeClass("emptyValue");
                                                                else
                                                                    this.input
                                                                        .addClass("keepValue")
                                                                        .attr("placeholder", Utilities_1.synUtil.Strings.getValue("synkeep").toUpperCase());
                                                            }
                                                        }).data("kendoComboBox");
                                                        ddlNew.closest(".k-widget").css({
                                                            "position": "absolute",
                                                            "left": ctrl.Input.left + "px",
                                                            "top": ctrl.Input.top + "px"
                                                        });
                                                        combo.input.css("padding", "0");
                                                        combo.input.attr("placeholder", Utilities_1.synUtil.Strings.getValue("synkeep").toUpperCase());
                                                        setColors();
                                                        wireFocusHandler(combo.input, "cestatedef.name");
                                                        stateComboAdded = true;
                                                    }
                                                    ctrl.Input.getDOMControl().remove();
                                                    if (ctrl.Button)
                                                        ctrl.Button.getDOMControl().remove();
                                                }
                                                else {
                                                    ctrl.Input.enable(false);
                                                    ctrl.Input.getInputControl().attr("title", Utilities_1.synUtil.Strings.getValue("nocommonfollowstate"));
                                                }
                                            }
                                        });
                                        // Remove from control collection
                                        const fieldsToRemove = [];
                                        $.each(ctrls.controlsByPresentedFieldName["cgdocument.stateid"], function (idx, ctrl) {
                                            if (ctrl.Input) {
                                                fieldsToRemove.push(ctrl.Input.field.fieldName);
                                                if (ctrl.Input.field.presentedField)
                                                    fieldsToRemove.push(ctrl.Input.field.presentedField);
                                            }
                                        });
                                        for (let i = 0; i < fieldsToRemove.length; i++) {
                                            if (ctrls.controlsByPresentedFieldName[fieldsToRemove[i]])
                                                delete ctrls.controlsByPresentedFieldName[fieldsToRemove[i]];
                                            if (ctrls.controlsByFieldName[fieldsToRemove[i]])
                                                delete ctrls.controlsByFieldName[fieldsToRemove[i]];
                                        }
                                        ctrls.allControls = $.grep(ctrls.allControls, function (ctrl) {
                                            return !ctrl.field || $.inArray(ctrl.field.fieldName, fieldsToRemove) < 0;
                                        });
                                    }
                                    // Replace checkboxes with custom controls
                                    propPagePane.find(".ppCheckBox").each(function (idx, elem) {
                                        const cb = $(elem).children("input:checkbox");
                                        const id = cb.attr("id");
                                        const tristate = $("<i class='fa' />)")
                                            .on('click', function () {
                                            if ($(this).hasClass("fa-check-square-o"))
                                                $(this).removeClass("fa-check-square-o").addClass("fa-square-o")
                                                    .attr("data-hasvalue", "true").removeAttr("checked").attr("title", "");
                                            else if ($(this).hasClass("fa-square-o"))
                                                $(this).removeClass("fa-square-o").addClass("fa-square")
                                                    .attr("data-hasvalue", "false").removeAttr("checked")
                                                    .attr("title", Utilities_1.synUtil.Strings.getValue("synkeep").toUpperCase());
                                            else if ($(this).hasClass("fa-square"))
                                                $(this).removeClass("fa-square").addClass("fa-minus")
                                                    .attr("data-hasvalue", "false").removeAttr("checked")
                                                    .attr("title", Utilities_1.synUtil.Strings.getValue("synempty").toUpperCase());
                                            else
                                                $(this).removeClass("fa-minus").addClass("fa-check-square-o")
                                                    .attr("checked", "checked").attr("data-hasvalue", "true").attr("title", "");
                                        })
                                            .addClass("fa-square").attr("data-hasvalue", "false")
                                            .attr("title", Utilities_1.synUtil.Strings.getValue("synkeep").toUpperCase())
                                            .insertAfter(cb);
                                        cb.remove();
                                        tristate.attr("id", id);
                                    });
                                    $("#" + configData.okButtonId)
                                        .prop("disabled", false)
                                        .on('click', function () {
                                        Utilities_1.synUtil.beginAjaxProgress($("#" + configData.okButtonId));
                                        const inst = propPagePane.synPropertyPage("getInstance");
                                        // These must always be passed
                                        const necessaryFields = ["cgdocument.instanzid",
                                            "cgdocument.typeid",
                                            "cgdocument.docid",
                                            "cgdocument.version"];
                                        const ctrls = propPagePane.data("synPropertyPage").controls;
                                        const mayBeDeleted = function (fieldName) {
                                            return $.inArray(fieldName, necessaryFields) < 0;
                                        };
                                        // Remove all fields from inst except:
                                        //   * fields that have been explicitly set (including their presented fields)
                                        //   * fields that have been explicitly set to empty value (including their presented fields)
                                        inst.skipAddEmptyFields = true; // inst is a "diff"-Instance --> do not fill missing fields with empty values on the server side!
                                        const mapRemainingFields = {};
                                        $.each(propPagePane.synPropertyPage("getChangedFields"), function (idx, field) {
                                            mapRemainingFields[field] = true;
                                        });
                                        $.each(ctrls.allControls, function (idx, ctrl) {
                                            if (ctrl.field) {
                                                if (ctrl.type === "CheckBoxInfo") {
                                                    if (ctrl.getInputControl().hasClass("fa-minus"))
                                                        mapRemainingFields[ctrl.field.fieldName] = true;
                                                }
                                                else if (ctrl.getInputControl().hasClass("emptyValue"))
                                                    mapRemainingFields[ctrl.field.fieldName] = true;
                                            }
                                        });
                                        $.each($.map(inst.items, function (field) {
                                            return field.name;
                                        }), function (idx, field) {
                                            if (mayBeDeleted(field)) {
                                                if (!mapRemainingFields[field]) {
                                                    if (ctrls.controlsByPresentedFieldName[field]) {
                                                        let bDelete = true;
                                                        $.each(ctrls.controlsByPresentedFieldName[field], function (idx, c) {
                                                            if (c.Input && mapRemainingFields[c.Input.field.fieldName]) {
                                                                bDelete = false;
                                                                return false;
                                                            }
                                                        });
                                                        if ((bDelete) && (field != "cgdocument.stateid"))
                                                            delete inst.items[field];
                                                    }
                                                    else if (field != "cgdocument.stateid")
                                                        // Warum muss hier explizit stateid ausgeschlossen werden?
                                                        // - Weil an dieser Stelle hier die StateId-Combobox aus der PropertyPage herausgelöscht und neu aufgebaut wird. Dann funktioniert gar nix mehr!
                                                        // - controlsByPresentedFieldName ist z.B. nicht mehr richtig gefüllt.
                                                        // Die eigentliche Lösung an dieser Stelle ist: dass die Propertypage selber die für cefunc.189 notwendige Funktionalität zur Verfügung stellt und an dieser
                                                        // Stelle nicht mehr so herumgetrickst werden muss!!
                                                        delete inst.items[field];
                                                }
                                            }
                                        });
                                        const combo = $("#stateCombo_" + windowData.guid).data("kendoComboBox");
                                        if (combo == undefined || combo == undefined || combo.input.hasClass("keepValue"))
                                            delete inst.items["cgdocument.stateid"];
                                        else {
                                            const item = combo.dataItem(combo.select());
                                            if (item && item.id)
                                                inst.items["cgdocument.stateid"].value = item.id;
                                        }
                                        // Early exit if all fields remain unchanged
                                        const allFields = $.map(inst.items, function (field) {
                                            return field.name;
                                        });
                                        if ($(allFields).not(necessaryFields).length === 0 && $(necessaryFields).not(allFields).length === 0) {
                                            Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("nochanges"));
                                            if (typeof window.synDesktopApp !== "undefined")
                                                window.synDesktopApp.endDialog("1");
                                            else
                                                $("#" + configData.windowID).data("kendoWindow").close();
                                            completedHandler(false);
                                        }
                                        else {
                                            let emptyFields = [];
                                            for (const fieldName in inst.items)
                                                if (inst.items[fieldName].isEmpty)
                                                    emptyFields.push(fieldName);
                                            Utilities_1.synUtil.executeMethod({
                                                method: "cefunc.189",
                                                instanceData: JSON.stringify([inst.toJSON()]),
                                                parentId,
                                                relId,
                                                additionalData: {
                                                    "cefunc.189selectedids": ids.join(";"),
                                                    "cefunc.189emptyfields": emptyFields.join(";")
                                                },
                                                done(dataJSON) {
                                                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                        let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                                        if (typeof window.synDesktopApp !== "undefined")
                                                            window.synDesktopApp.endDialog("1");
                                                        else
                                                            $("#" + configData.windowID).data("kendoWindow").close();
                                                        if (completedHandler)
                                                            completedHandler(true, data);
                                                    });
                                                },
                                                cleanUp() {
                                                    Utilities_1.synUtil.endAjaxProgress($("#" + configData.okButtonId));
                                                }
                                            });
                                        }
                                    });
                                    $("#" + configData.cancelButtonId).on('click', function () {
                                        if (typeof window.synDesktopApp !== "undefined")
                                            window.synDesktopApp.endDialog("0");
                                        else
                                            $("#" + configData.windowID).data("kendoWindow").close();
                                    });
                                    // Remove background-image of PropertyPage
                                    propPagePane.children(".ppContainer").css("background-image", "");
                                })
                                    .on("instanceReceived", function (evt, instance) {
                                    for (const prop in instance.items)
                                        if ($.inArray(prop, ["id", "cgdocument.instanzid", "cgdocument.typeid"]) < 0)
                                            instance.items[prop].value = instance.items[prop].multiValue ? [] : undefined;
                                })
                                    .on("valuesChanged", setColors)
                                    .on("controlChanged", function (evt, control) {
                                    let val = control.getValue();
                                    if (control.field.isFTField && control.field.presentedField) {
                                        const curInst = propPagePane.synPropertyPage("getInstance");
                                        val = curInst.items[control.field.presentedField].value;
                                    }
                                    if (control.type !== "CheckBoxInfo") {
                                        if (val)
                                            control.getInputControl().removeAttr("placeholder");
                                        else
                                            control.getInputControl().attr("placeholder", Utilities_1.synUtil.Strings.getValue("synkeep").toUpperCase());
                                        setColorForControl(control, val);
                                    }
                                })
                                    .on("controlRecreated", function (evt, control) {
                                    if (control.type === "FTComboBoxInfo")
                                        wireFocusHandler(control, control.field.fieldName);
                                })
                                    .on("valuesReverted", function () {
                                    setColors();
                                })
                                    .synPropertyPage();
                                propPagePane.synPropertyPage("setTemplate", {
                                    mode: 3,
                                    typeId: parseInt(ids[0].split("|")[2], 10),
                                    ignoreAllReadOnlyFields: true,
                                    cleanUp() {
                                        "Method not implemented.";
                                    }
                                });
                            });
                        });
                    },
                    cleanUp() {
                        Utilities_1.synUtil.endAjaxProgress();
                    }
                });
            }
        },
        // Kopieren zum Clipboard
        "195": {
            impl(ids, parentId, relId) {
                if (Utilities_1.synUtil.useSynerisWorkspace) {
                    Utilities_1.synUtil.executeMethod({
                        method: "cefunc.195",
                        ids,
                        parentId,
                        relId,
                        done(dataJSON) {
                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                const result = JSON.parse(data.additionalInformation["cefunc.195result"]);
                                Utilities_1.synUtil.openWorkspace("synerisws" + result.instanceId + "://common/copywindows/" + result.instanceId + "/" + result.cacheId);
                            });
                        },
                        fail(jqXHR, textStatus, errorThrown, url) {
                            Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                        }
                    });
                }
                else
                    Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("useworkspaceforcopywindows"));
            }
        },
        // Display coordinates on map
        "208": {
            impl(ids, parentId, relId, completedHandler, options) {
                // Create Window
                const windowData = Utilities_1.synUtil.popupWindow({
                    title: Utilities_1.synUtil.Strings.getValue("cefunc.208"),
                    actions: ["Maximize", "Close"],
                    width: 1024,
                    height: 768,
                    resizable: true,
                    modal: true,
                    synDesktopAware: false
                });
                const idsArr = ids;
                if (ids.length === 1 && options && options.version && !options.version.verCur)
                    idsArr[0] += "|" + options.version.version;
                windowData.beginInit();
                require.ensure(["../../../node_modules/leaflet/dist/leaflet.css", "../../../node_modules/leaflet/dist/leaflet.js"], (require) => {
                    const leafletCss = require("../../../node_modules/leaflet/dist/leaflet.css");
                    const L = require("../../../node_modules/leaflet/dist/leaflet.js");
                    delete L.Icon.Default.prototype._getIconUrl;
                    L.Icon.Default.mergeOptions({
                        iconRetinaUrl: require("../../../node_modules/leaflet/dist/images/marker-icon-2x.png"),
                        iconUrl: require("../../../node_modules/leaflet/dist/images/marker-icon.png"),
                        shadowUrl: require("../../../node_modules/leaflet/dist/images/marker-shadow.png")
                    });
                    Utilities_1.synUtil.executeMethod({
                        method: "cefunc.208",
                        ids: idsArr,
                        parentId,
                        relId,
                        additionalData: { "cefunc.208action": "config" },
                        done(dataJSON) {
                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                windowData.endInit();
                                const result = JSON.parse(data.additionalInformation["cefunc.208result"]);
                                // Create map
                                const mapId = "map_" + Utilities_1.synUtil.getGUID(true);
                                const $div = $("<div></div>")
                                    .css({
                                    "height": "100%",
                                    "width": "100%"
                                })
                                    .attr({
                                    "id": mapId
                                })
                                    .appendTo(windowData.contentDiv);
                                const map = L.map(mapId, { worldCopyJump: true }).setView([47.8095, 13.0550], 3);
                                // Load tiles
                                if (result.mapboxToken === "") {
                                    const osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
                                    const osmAttrib = 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors';
                                    const tileMap = new L.TileLayer(osmUrl, { minZoom: 2, maxZoom: 19, attribution: osmAttrib });
                                    map.addLayer(tileMap);
                                }
                                else {
                                    L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
                                        attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
                                        minZoom: 2,
                                        maxZoom: 20,
                                        tileSize: 512,
                                        zoomOffset: -1,
                                        id: 'streets-v10',
                                        accessToken: result.mapboxToken
                                    }).addTo(map);
                                }
                                // Set markers
                                const bounds = new L.LatLngBounds();
                                let markersExist = false;
                                // for (let instance in result.instances) {
                                $.each(result.instances, function () {
                                    const lat = this.lat;
                                    const lng = this.lng;
                                    if (lat != undefined && lng != undefined) {
                                        markersExist = true;
                                        if (this.mapMarkerIcon === "") {
                                            const newMarker = L.marker([lat, lng])
                                                .bindPopup(this.html)
                                                .addTo(map);
                                        }
                                        else {
                                            const customIcon = L.icon({
                                                iconUrl: Utilities_1.synUtil.getWSUrl("Icon") + "docid=" + this.mapMarkerIcon + "/32",
                                                iconSize: [32, 32],
                                                iconAnchor: [16, 16],
                                                popupAnchor: [0, -10],
                                            });
                                            const newMarker = L.marker([lat, lng], { icon: customIcon })
                                                .bindPopup(this.html)
                                                .addTo(map);
                                        }
                                        bounds.extend([lat, lng]);
                                    }
                                });
                                if (!markersExist) {
                                    Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("mapfeature.novalidcoordinates"));
                                    $("#" + windowData.windowID).data("kendoWindow").close();
                                }
                                else
                                    map.fitBounds(bounds.pad(0.5));
                            });
                        }
                    });
                });
            }
        },
        // Videoplayer for Web
        "218": {
            impl(ids, parentId, relId, completedHandler) {
                if (ids.length !== 1) {
                    // @ts-ignore
                    noty({
                        layout: "center",
                        type: "warning",
                        text: "Please select a video for playback",
                        timeout: 5000
                    });
                    return;
                }
                const markup = require("../../templates/webvideoplayer.tmpl.html");
                // Create Window
                const windowData = Utilities_1.synUtil.popupWindow({
                    title: "Video Player",
                    actions: ["Close"],
                    width: 1300,
                    height: 800,
                    resizable: false,
                    modal: true,
                    synDesktopAware: true
                });
                // IE 10 does not support window.location.origin so build it here
                const origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + window.location.pathname;
                // Initialize contents
                const configData = {
                    synUtil: Utilities_1.synUtil,
                    videoSourceURL: origin + Utilities_1.synUtil.getWSUrl("ContentInstanceDownload") + ids[0] + "/1",
                    windowID: "popup_" + windowData.guid,
                    closeButtonId: "closeButton_" + windowData.guid
                };
                // Create HTML from template
                const template = kendo.template(markup);
                windowData.contentDiv.html(template(configData));
                $("#" + configData.closeButtonId).on('click', function () {
                    if (typeof window.synDesktopApp !== "undefined")
                        window.synDesktopApp.endDialog("0");
                    else
                        $("#" + configData.windowID).data("kendoWindow").close();
                });
            }
        },
        // former synlinzagext.8
        "221": {
            selCount: -1,
            impl(ids, parentId, relId, completedHandler, options) {
                const dummyDateForOneTimeInstructions = new Date(1970, 0, 1);
                const _isInRange = function (val, range) {
                    if (range.from != undefined && range.from > val)
                        return false;
                    if (range.to != undefined && range.to < val)
                        return false;
                    return true;
                };
                /**
                * Returns the amount of whole days a task is overdue. If the task is not overdue, the value
                * is negative. For a task being due today, 0 will be returned. If value is undefined, undefined will
                * be returned.
                 * @param {Date} dueDate Due date.
                 * @return {number} The amount of whole days a task is overdue.
                */
                const _getOverdueDays = function (dueDate) {
                    if (!dueDate)
                        return undefined;
                    const now = moment(new Date()).startOf("day");
                    const due = moment(dueDate);
                    return now.diff(due, "days");
                };
                const _getTrafficLightForOverdueDays = function (overdueDays) {
                    if (overdueDays == undefined)
                        return "";
                    for (const prop in _trafficLightThresholds) {
                        const range = _trafficLightThresholds[prop];
                        if (_isInRange(overdueDays, range))
                            return prop;
                    }
                };
                const _debouncedResize = _.debounce(function ($matrix, $matrixContainer) {
                    $matrix.synMatrix("resize", $matrixContainer.innerWidth(), $matrixContainer.innerHeight());
                }, 100);
                const _resizeMatrix = function ($matrix, $matrixContainer) {
                    _debouncedResize($matrix, $matrixContainer);
                };
                const _trafficLightThresholds = {
                    "red": { from: 1, to: undefined },
                    "yellow": { from: -6, to: 0 },
                    "green": { from: undefined, to: -7 },
                };
                const _viewMergedPdf = function (ids, parentId, relId, udoIdList, data, close) {
                    if (typeof window.synDesktopApp !== "undefined") {
                        window.synDesktopApp.set_resultValue(udoIdList);
                        window.synDesktopApp.endDialog("1");
                    }
                    else {
                        if (data.additionalInformation["cefunc.221viewmergedpdf"]) {
                            const guid = Utilities_1.synUtil.getGUID();
                            const dataobj = {
                                "cefunc.221udoidlist": udoIdList,
                                tempPathGUID: guid,
                                tempPathTarget: "cefunc.221exportpath"
                            };
                            const contentTempDownloadableUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownloadable");
                            const contentTempDownloadUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownload");
                            Utilities_1.synUtil.executeMethod({
                                method: "cefunc.221",
                                ids,
                                parentId,
                                relId,
                                done(data2) {
                                    close();
                                    Utilities_1.synUtil.getAJAXData({
                                        url: contentTempDownloadableUrl + guid + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken,
                                        done(data3) {
                                            if (data3.downloadable)
                                                $.fileDownload(contentTempDownloadUrl + guid + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken + "&forceAttachment=true");
                                        }
                                    });
                                },
                                cleanUp() {
                                    "Method not implemented.";
                                },
                                additionalData: dataobj
                            });
                        }
                        else
                            close();
                    }
                };
                Utilities_1.synUtil.beginAjaxProgress();
                Utilities_1.synUtil.executeMethod({
                    method: "cefunc.221",
                    ids,
                    parentId,
                    relId,
                    done(udosExistDataJSON) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            let udosExistData = yield MethodServerResponse_1.MethodServerResponse.fromJSON(udosExistDataJSON);
                            const markup = require("../../templates/cefunc_221.tmpl.html");
                            require.ensure(["../../templates/cefunc_221.less"], function (require) {
                                require("../../templates/cefunc_221.less");
                                // Create Window
                                const windowData = Utilities_1.synUtil.popupWindow({
                                    title: Utilities_1.synUtil.Strings.getValue("cefunc.221"),
                                    actions: ["Maximize", "Close"],
                                    width: 900,
                                    height: 600,
                                    resizable: true,
                                    modal: true,
                                    synDesktopAware: true
                                });
                                windowData.beginInit();
                                Utilities_1.synUtil.getAJAXData({
                                    url: Utilities_1.synUtil.getWSUrl("UserInfo"),
                                    done: (userDataJSON) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                        // #region Initialize window contents
                                        const udoQueryDocId = Utilities_1.synUtil.Configs.getValue("cefunc.221.udoquerydocid", undefined);
                                        const configData = {
                                            synUtil: Utilities_1.synUtil,
                                            windowID: "popup_" + windowData.guid,
                                            matrixContainerId: "matrixContainer_" + windowData.guid,
                                            matrixId: "matrix_" + windowData.guid,
                                            buttonBarId: "buttonBar_" + windowData.guid,
                                            okButtonId: "okButton_" + windowData.guid,
                                            cancelButtonId: "cancelButton_" + windowData.guid,
                                            openUdoQueryLinkId: "openUdoQueryLink_" + windowData.guid,
                                            udosExist: "Y" === udosExistData.additionalInformation["cefunc.221udosexist"],
                                            udoQueryDocId
                                        };
                                        // Create HTML from template
                                        const template = kendo.template(markup);
                                        windowData.contentDiv.html(template(configData));
                                        $("#" + configData.openUdoQueryLinkId).on("click", function () {
                                            if (udoQueryDocId)
                                                MethodManager_1.MethodManager.executeMethod("cefunc.18", [udoQueryDocId.toString()], undefined, 0, function (s, e) {
                                                    "Method not implemented.";
                                                }, undefined);
                                        });
                                        $("#" + configData.windowID).data("kendoWindow").bind("resize", () => {
                                            _resizeMatrix($matrix, $matrixContainer);
                                        });
                                        // #region Initialize Matrix
                                        const $matrixContainer = $("#" + configData.matrixContainerId);
                                        const $matrix = $("#" + configData.matrixId);
                                        let initiallySelectedTag;
                                        const selectedTagField = Utilities_1.synUtil.Configs.getValue("cefunc.221.initiallyselectedttagfield", undefined);
                                        let instance = yield Instance_1.Instance.fromJSON(userDataJSON.instance);
                                        if (selectedTagField && instance.items[selectedTagField]) {
                                            const field = instance.items[selectedTagField];
                                            if (field.multiValue && field.valueAsArray.length)
                                                initiallySelectedTag = field.value[0];
                                            else if (!field.multiValue && field.value)
                                                initiallySelectedTag = field.value;
                                        }
                                        $matrix
                                            .on("initSuccess", () => {
                                            _resizeMatrix($matrix, $matrixContainer);
                                        })
                                            .on("selectionChanged", () => {
                                            const keyCount = Object.keys($matrix.synMatrix("getSelection")).length;
                                            Utilities_1.synUtil.toggleEnabledState($("#" + configData.okButtonId), keyCount > 0);
                                        })
                                            .synMatrix({
                                            matrixId: "training",
                                            width: $matrixContainer.innerWidth(),
                                            height: $matrixContainer.innerHeight(),
                                            userHierarchyStartField: "ceaddress.matrixknoten",
                                            initiallySelectedTag,
                                            rowClickMode: Matrix_1.RowClickMode.RowSelection_All,
                                            colClickMode: Matrix_1.ColumnClickMode.Properties,
                                            cellSelectionMode: Matrix_1.CellSelectionMode.Inherit,
                                            // @ts-ignore
                                            cellRenderFunc: (physicalRowIdx, physicalColIdx, td, value, matrixData) => {
                                                td.innerHTML = "";
                                                let title = "";
                                                if (value) {
                                                    const additionalData = value.additionalData || {};
                                                    if (value.value && value.value.getTime() !== dummyDateForOneTimeInstructions.getTime()) {
                                                        const overdueDays = _getOverdueDays(value.value);
                                                        const trafficLightValue = _getTrafficLightForOverdueDays(overdueDays);
                                                        if (trafficLightValue) {
                                                            const row = matrixData.dfsIndexMap[physicalRowIdx];
                                                            const col = matrixData.columns[physicalColIdx];
                                                            td.className += " trafficLight " + trafficLightValue;
                                                            const absDays = Math.abs(overdueDays);
                                                            if (trafficLightValue === "red")
                                                                title = "Überfällig seit " + absDays + " Tag" + (absDays > 1 ? "en" : "");
                                                            else if (absDays === 0)
                                                                title = "Fällig heute";
                                                            else
                                                                title = "Fällig in " + absDays + " Tag" + (absDays > 1 ? "en" : "");
                                                        }
                                                    }
                                                    else if (additionalData.oneTimeInstruction) {
                                                        td.className += " trafficLight oneTimeInstruction";
                                                        title = " Einmalige Unterweisung";
                                                    }
                                                    if (additionalData.lastInstruction) {
                                                        const lastInstructionDate = Utilities_1.synUtil.jsonToDate(additionalData.lastInstruction);
                                                        if (title)
                                                            title += "\n";
                                                        title += "Letzte Unterweisung: " + kendo.toString(lastInstructionDate, "d");
                                                    }
                                                    if (title)
                                                        td.title = title;
                                                }
                                                return;
                                            },
                                            columnFilterPredicate: (col, srvData) => {
                                                for (const r of srvData) {
                                                    if (r.values && r.values[col.id] && r.values[col.id].value)
                                                        return true;
                                                }
                                                return false;
                                            }
                                        });
                                        // #endregion
                                        // #region Initialize Buttons
                                        $("#" + configData.cancelButtonId).on('click', () => {
                                            if (typeof window.synDesktopApp !== "undefined")
                                                window.synDesktopApp.endDialog("0");
                                            else
                                                $("#" + configData.windowID).data("kendoWindow").close();
                                        });
                                        $("#" + configData.okButtonId).on('click', () => {
                                            Utilities_1.synUtil.beginAjaxProgress("#" + configData.okButtonId);
                                            let udoLinkType = "web";
                                            if (typeof window.synDesktopApp !== "undefined")
                                                udoLinkType = "windows";
                                            const dataobj = {
                                                "cefunc.221action": "getudolist",
                                                "cefunc.221usersandlessons": JSON.stringify($matrix.synMatrix("getSelection")),
                                                "cefunc.221udolinktype": udoLinkType
                                            };
                                            Utilities_1.synUtil.executeMethod({
                                                method: "cefunc.221",
                                                ids,
                                                parentId,
                                                relId,
                                                done(dataJSON) {
                                                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                        let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                                        const udoIdList = data.additionalInformation["cefunc.221udoidlist"];
                                                        if (data.additionalInformation["cefunc.221udonamelist"]) {
                                                            const udoNameList = JSON.parse(data.additionalInformation["cefunc.221udonamelist"]);
                                                            const templateMarkup = require("../../templates/cefunc_221_udo_list.tmpl.html");
                                                            const windowData2 = Utilities_1.synUtil.popupWindow({
                                                                title: Utilities_1.synUtil.Strings.getValue("cefunc.221udoidlist"),
                                                                width: 600,
                                                                height: 400,
                                                                resizable: false,
                                                                modal: true,
                                                                synDesktopAware: true
                                                            });
                                                            const configData2 = {
                                                                synUtil: Utilities_1.synUtil,
                                                                windowID: "popup_" + windowData2.guid,
                                                                contentDiv: "contentDiv_" + windowData2.guid,
                                                                udoTableId: "udoTableId_" + windowData2.guid,
                                                                closeButtonId: "closeButtonId_" + windowData2.guid
                                                            };
                                                            // Create HTML from template
                                                            const template = kendo.template(templateMarkup);
                                                            windowData2.contentDiv.css("box-sizing", "border-box").html(template(configData2));
                                                            const tableRef = document.getElementById(configData2.udoTableId).getElementsByTagName('tbody')[0];
                                                            // Set table headers
                                                            const newRow = tableRef.insertRow(0);
                                                            let newCell = newRow.insertCell(0);
                                                            $(newCell).css("border", "1px solid grey");
                                                            $(newCell).css("padding-left", "10px");
                                                            $(newCell).css("padding-right", "10px");
                                                            $(newCell).css("vertical-align", "middle");
                                                            $(newCell).css("background-color", "#E5EBF0");
                                                            const newElement = document.createElement('h4');
                                                            $(newElement).css("font-weight", "bold");
                                                            newElement.innerText = Utilities_1.synUtil.Strings.getValue("cefunc.221udoheader1");
                                                            newCell.appendChild(newElement);
                                                            newCell = newRow.insertCell(1);
                                                            $(newCell).css("border", "1px solid grey");
                                                            $(newCell).css("padding-left", "10px");
                                                            $(newCell).css("padding-right", "10px");
                                                            $(newCell).css("vertical-align", "middle");
                                                            $(newCell).css("background-color", "#E5EBF0");
                                                            const newElement2 = document.createElement('h4');
                                                            $(newElement2).css("font-weight", "bold");
                                                            newElement2.innerText = Utilities_1.synUtil.Strings.getValue("cefunc.221udoheader2");
                                                            newCell.appendChild(newElement2);
                                                            // Build table with udo names and links
                                                            for (let i = 0; i < udoNameList.length; i++) {
                                                                const udo = udoNameList[i];
                                                                const newRow = tableRef.insertRow(tableRef.rows.length);
                                                                // Name of udo including link to its property page
                                                                newCell = newRow.insertCell(0);
                                                                $(newCell).css("border", "1px solid grey");
                                                                $(newCell).css("padding-left", "10px");
                                                                $(newCell).css("padding-right", "10px");
                                                                $(newCell).css("vertical-align", "middle");
                                                                const newElement3 = document.createElement('a');
                                                                if (udoLinkType === "windows") {
                                                                    newElement3.setAttribute("href", udo.link);
                                                                    newElement3.innerText = udo.name;
                                                                }
                                                                else {
                                                                    newElement3.setAttribute("href", udo.link);
                                                                    newElement3.setAttribute("target", "_blank");
                                                                    newElement3.innerText = udo.name;
                                                                }
                                                                newCell.appendChild(newElement3);
                                                                // Number of users and popup with list of user names
                                                                newCell = newRow.insertCell(1);
                                                                $(newCell).css("border", "1px solid grey");
                                                                $(newCell).css("padding-left", "10px");
                                                                $(newCell).css("padding-right", "10px");
                                                                $(newCell).css("vertical-align", "middle");
                                                                $(newCell).css("text-align", "right");
                                                                const newElement4 = document.createElement('h5');
                                                                newElement4.innerText = udo.users.length;
                                                                newElement4.title = udo.users.join("\r\n");
                                                                newElement4.style.cursor = "help";
                                                                newCell.appendChild(newElement4);
                                                            }
                                                            // Close button click event
                                                            $("#" + configData2.closeButtonId).on('click', function () {
                                                                _viewMergedPdf(ids, parentId, relId, udoIdList, data, function () {
                                                                    if (typeof window.synDesktopApp !== "undefined")
                                                                        window.synDesktopApp.endDialog("0");
                                                                    else
                                                                        $("#" + configData2.windowID).data("kendoWindow").close();
                                                                    $("#" + configData.windowID).data("kendoWindow").close();
                                                                    if (completedHandler)
                                                                        completedHandler(true, data);
                                                                });
                                                            });
                                                        }
                                                        else {
                                                            _viewMergedPdf(ids, parentId, relId, udoIdList, data, function () {
                                                                $("#" + configData.windowID).data("kendoWindow").close();
                                                                if (completedHandler)
                                                                    completedHandler(true, data);
                                                            });
                                                        }
                                                    });
                                                },
                                                cleanUp() {
                                                    Utilities_1.synUtil.endAjaxProgress("#" + configData.okButtonId);
                                                },
                                                additionalData: dataobj
                                            });
                                        });
                                        // #endregion
                                        // #endregion
                                    }),
                                    cleanUp: windowData.endInit
                                });
                            });
                        });
                    },
                    cleanUp() {
                        Utilities_1.synUtil.endAjaxProgress();
                    },
                    additionalData: { "cefunc.221action": "checkudosexist" }
                });
            }
        },
        "225": {
            impl(ids, parentId, relId, completedHandler) {
                const instId = ids[0];
                const markup = require("../../templates/checklist_designer.tmpl.html");
                // Create Window
                const windowData = Utilities_1.synUtil.popupWindow({
                    title: "Checklist",
                    actions: ["Maximize", "Close"],
                    width: 1024,
                    height: 768,
                    resizable: true,
                    modal: true,
                    synDesktopAware: true,
                    preventCloseOnEscpae: true,
                });
                $("#" + windowData.windowID).data("kendoWindow").maximize();
                // Initialize contents
                const configData = {
                    synUtil: Utilities_1.synUtil,
                    windowID: "popup_" + windowData.guid,
                    designerlLayout: "designerllayout" + windowData.guid,
                    designerTemplateColumn: "designertemplatecolumn" + windowData.guid,
                    designerControlColumn: "designercontrolcolumn" + windowData.guid,
                    designerChecklistPropertiesColumn: "designergeneralpropertiescolumn" + windowData.guid,
                    designerFieldPropertiesColumn: "designerpropertiescolumn" + windowData.guid,
                    saveButtonId: "saveButton_" + windowData.guid,
                    savecloseButtonId: "savecloseButton_" + windowData.guid,
                    cancelButtonId: "cancelButton_" + windowData.guid,
                    designerPropertySplitter: "designerpropertysplitter_" + windowData.guid,
                };
                // Create HTML from template
                const template = kendo.template(markup);
                windowData.contentDiv.html(template(configData));
                configData["loadingDiv"] = $("<div class='k-loading-image'></div>").appendTo($("#" + configData.designerlLayout));
                const checklistInstanceUrl = Utilities_1.synUtil.getWSUrl("ChecklistGetInstance");
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: checklistInstanceUrl,
                    requestData: JSON.stringify({ id: instId, checkout: true, fordesigner: true }),
                    done(instance) {
                        const checklistPane = $("#" + configData.designerlLayout);
                        checklistPane.synChecklist();
                        const saveInstance = function (close, buttonId) {
                            checklistPane.synChecklist("save", buttonId, close, instId, configData);
                        };
                        let isClosing = false;
                        $("#" + configData.designerlLayout).on("clsave", function () {
                            saveInstance(false, undefined);
                        });
                        $("#" + configData.saveButtonId).on('click', function () {
                            saveInstance(false, "#" + configData.saveButtonId);
                        });
                        $("#" + configData.savecloseButtonId).on('click', function () {
                            saveInstance(true, "#" + configData.savecloseButtonId);
                        });
                        $("#" + configData.cancelButtonId).on('click', function () {
                            $("#" + configData.windowID).data("kendoWindow").close();
                        });
                        $("#" + configData.windowID).data("kendoWindow").bind("close", function (e) {
                            if (!isClosing) {
                                e.preventDefault();
                                const closeCallback = function (close) {
                                    if (close) {
                                        isClosing = true;
                                        $("#" + configData.windowID).data("kendoWindow").close();
                                    }
                                };
                                checklistPane.synChecklist("close", instId, closeCallback);
                            }
                        });
                        const sourceTypeId = parseInt(ids[0].split("|")[2], 10);
                        let mode = ChecklistControls_1.ChecklistMode.Designer;
                        if (sourceTypeId === 999999930)
                            mode |= ChecklistControls_1.ChecklistMode.Questionnaire;
                        let calledFromFatCient = false;
                        if (window.synDesktopApp)
                            calledFromFatCient = true;
                        checklistPane.synChecklist("showDesigner", configData, instance, mode, $("#" + windowData.windowID), calledFromFatCient);
                    },
                    fail(jqXHR, textStatus, errorThrown, url) {
                        Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url, false);
                        if (window.synDesktopApp)
                            window.synDesktopApp.endDialog("1");
                        else
                            $("#" + configData.windowID).data("kendoWindow").close();
                    }
                });
            }
        },
        "228": (require("./cefunc/cefunc_228")).default,
        "233": {
            impl(ids, parentId, relId, completedHandler) {
                "Method not implemented.";
            }
        },
        // doViewRecursiveMergedPDF
        "240": {
            impl(ids, parentId, relId, completedHandler) {
                const guid = Utilities_1.synUtil.getGUID();
                const dataobj = {
                    tempPathGUID: guid,
                    tempPathTarget: "cefunc.240exportpath"
                };
                const contentTempDownloadableUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownloadable");
                const contentTempDownloadUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownload");
                Utilities_1.synUtil.executeMethod({
                    method: "cefunc.240",
                    ids,
                    parentId,
                    relId,
                    done() {
                        Utilities_1.synUtil.getAJAXData({
                            url: contentTempDownloadableUrl + guid,
                            done(data) {
                                if (data.downloadable)
                                    $.fileDownload(contentTempDownloadUrl + guid + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken + "&forceAttachment=true");
                            }
                        });
                    },
                    additionalData: dataobj
                });
            }
        }
    },
    celoggerext: {
        // Report für Historie erstellen
        "3": {
            impl(ids, parentId, relId, completedHandler) {
                const guid = Utilities_1.synUtil.getGUID();
                const dataobj = {
                    "tempPathGUID": guid,
                    "tempPathTarget": "celogginreportfilename"
                };
                const contentTempDownloadableUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownloadable");
                const contentTempDownloadUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownload");
                Utilities_1.synUtil.executeMethod({
                    method: "celoggerext.3",
                    ids,
                    parentId,
                    relId,
                    done() {
                        Utilities_1.synUtil.getAJAXData({
                            url: contentTempDownloadableUrl + guid + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken,
                            done(data) {
                                if (data.downloadable) {
                                    window.open(contentTempDownloadUrl + guid + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken + "&inline=Y", "_blank");
                                }
                            }
                        });
                        Utilities_1.synUtil.Notifications.menuSuccess("celoggerext.3");
                        if (completedHandler)
                            completedHandler(false);
                    },
                    additionalData: dataobj
                });
            }
        }
    },
    cemanagsys: {
        "29": {
            impl(ids, parentId, relId, completedHandler, options) {
                const instanzId = ids[0].split("|")[0];
                const configData = {
                    "cemanagsys.29action": "config",
                    bestid: undefined
                };
                if (options) {
                    if (options.confObjectId)
                        configData.bestid = options.confObjectId;
                    if (options["cemanagsys.29selectedchoicecid"])
                        configData["cemanagsys.29selectedchoicecid"] = options["cemanagsys.29selectedchoicecid"];
                }
                Utilities_1.synUtil.executeMethod({
                    method: "cemanagsys.29",
                    ids,
                    parentId,
                    relId,
                    additionalData: configData,
                    done(dataJSON) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                            require.ensure(["../../templates/cemanagsys_29.less"], (require) => {
                                const cemanagsys_29_less = require("../../templates/cemanagsys_29.less");
                                const templateMarkup = require("../../templates/cemanagsys_29.tmpl.html");
                                // Add choice options
                                const choiceList = JSON.parse(data.additionalInformation["cemanagsys.29actionchoicelist"]);
                                const reasonLineCount = choiceList[0].reason.split(/\r\n|\r|\n/).length;
                                let pwdSizedIn = false;
                                let statementSizedIn = false;
                                let reasonSizedIn = false;
                                let choiceListHeight = Math.ceil(choiceList.length / 5) * 2.125 + 0.625;
                                let maxWidth = 0;
                                // Create Window
                                const windowData = Utilities_1.synUtil.popupWindow({
                                    title: Utilities_1.synUtil.Strings.getValue("cemanagsys.29"),
                                    width: 25,
                                    height: 4.0625 + choiceListHeight,
                                    resizable: false,
                                    modal: true,
                                    synDesktopAware: true
                                });
                                // Initialize contents
                                const configData = {
                                    synUtil: Utilities_1.synUtil,
                                    splitterId: "splitter_" + windowData.guid,
                                    reasonId: "reason_" + windowData.guid,
                                    pwdTextBoxId: "pwdBox_" + windowData.guid,
                                    reasonTextBoxId: "reasonTextBox_" + windowData.guid,
                                    okButtonId: "okButton_" + windowData.guid,
                                    buttonPaneId: "buttonPaneId_" + windowData.guid,
                                    cancelButtonId: "cancelButton_" + windowData.guid,
                                    textPaneId: "textPane_" + windowData.guid,
                                    choicePaneId: "choicePane_" + windowData.guid,
                                    windowID: "popup_" + windowData.guid,
                                    pwdLabelDiv: "pwdLabelDiv_" + windowData.guid,
                                    reasonLabelDiv: "reasonLabelDiv_" + windowData.guid,
                                    reasonTextBoxDiv: "reasonTextBoxDiv_" + windowData.guid,
                                    pwdTextBoxDiv: "pwdTextBoxDiv_" + windowData.guid,
                                    choiceContainer: "choiceContainer_" + windowData.guid,
                                    infoPaneId: "infoPaneId_" + windowData.guid,
                                    messageDiv: "messageDiv_" + windowData.guid,
                                    messageIconDiv: "messageIconDiv_" + windowData.guid,
                                    maxStatementLength: parseInt(data.additionalInformation["cemanagsys.29maxstatementlength"], 10)
                                };
                                // Create HTML from template
                                const template = kendo.template(templateMarkup);
                                windowData.contentDiv.html(template(configData));
                                $("#" + configData.textPaneId).height(0);
                                $("#" + configData.choicePaneId).height(choiceListHeight + "em");
                                $("#" + configData.messageDiv).height(0);
                                // if window is closed, polling must stop
                                let windowClosed = false;
                                $("#" + configData.windowID)
                                    .data("kendoWindow")
                                    .bind("close", function (e) {
                                    windowClosed = true;
                                });
                                $(window).on("orientationchange", function (event) {
                                    setTimeout(function () {
                                        resizeWidth();
                                        resizeHeight(pwdSizedIn, statementSizedIn, reasonSizedIn);
                                        centerWindow();
                                    }, 250);
                                });
                                $(window).on("resize", function (event) {
                                    setTimeout(function () {
                                        centerWindow();
                                    }, 250);
                                });
                                for (let i = 0; i < choiceList.length; i++) {
                                    const choice = choiceList[i];
                                    const button = $("<button type='button' id='choice_" + choice.id + "' class='btn choiceButton' />")
                                        .text(choice.name)
                                        .appendTo($("#" + configData.choiceContainer))
                                        .data("choiceOptions", choice);
                                    const icon = choice.iconId ? "docid=" + choice.iconId.toString() : "transparent";
                                    button.prepend($("<image src='" + Utilities_1.synUtil.getWSUrl("Icon") + icon + "/16" + "' alt='' />"));
                                }
                                const resizeWidth = function () {
                                    let buttonWidth = 1.25;
                                    let rows = 1;
                                    const windowWidth = $(window).width() / parseFloat($("body").css("font-size"));
                                    let minWidth = Math.min(23.4375, windowWidth);
                                    if (Utilities_1.synUtil.clientDeviceClass === "phone" || Utilities_1.synUtil.clientDeviceClass === "tablet")
                                        maxWidth = minWidth = windowWidth;
                                    $("#" + configData.choiceContainer).find("button.choiceButton")
                                        .each(function (idx, elem) {
                                        const currentButton = $(elem).innerWidth() / parseFloat($("body").css("font-size")) + 0.9;
                                        buttonWidth = buttonWidth + currentButton;
                                        if (buttonWidth < minWidth)
                                            buttonWidth = minWidth;
                                        if (rows === 1 && buttonWidth < Math.min(82.5, windowWidth))
                                            maxWidth = buttonWidth;
                                        else if (rows > 1 && maxWidth < minWidth)
                                            maxWidth = minWidth;
                                        if (buttonWidth > maxWidth) {
                                            buttonWidth = currentButton + 1.25;
                                            rows = rows + 1;
                                        }
                                    });
                                    choiceListHeight = rows * 3 + 0.625;
                                    if (Utilities_1.synUtil.clientDeviceClass === "phone" || Utilities_1.synUtil.clientDeviceClass === "tablet")
                                        choiceListHeight = rows * 3.5 + 0.625;
                                    // resize window
                                    $(".k-widget.k-window").width(maxWidth + 5 + "em");
                                    $("#" + configData.choicePaneId).height(choiceListHeight + "em");
                                    $("#" + configData.choicePaneId).resize();
                                    $("#" + configData.splitterId).height(choiceListHeight + "em");
                                    $("#" + configData.splitterId).resize();
                                };
                                const centerWindow = function () {
                                    if ((Utilities_1.synUtil.clientDeviceClass !== "phone" && Utilities_1.synUtil.clientDeviceClass !== "tablet") && maxWidth !== 0) { // only center if popup.width < 90% of window.width {
                                        $(".k-widget.k-window").css({
                                            'position': 'fixed',
                                            'top': ($(window).height() / 2) - ($(".k-widget.k-window").height() / 2),
                                            'left': ($(window).width() / 2) - ($(".k-widget.k-window").width() / 2)
                                        });
                                    }
                                };
                                // Has to be done like this, because otherwise widths would be wrong the first time after browser
                                // has been started due to race condition involving the application of the CSS's styles.
                                setTimeout(function () {
                                    resizeWidth();
                                    resizeHeight(pwdSizedIn, statementSizedIn, reasonSizedIn);
                                    centerWindow();
                                }, 250);
                                // True: all required fields have been supplied, else false
                                const validate = function () {
                                    const activeButton = $("#" + configData.choiceContainer).find("button.choiceButton.active");
                                    const pwdBox = $("#" + configData.pwdTextBoxId);
                                    const reasonBox = $("#" + configData.reasonTextBoxId);
                                    let valid = true;
                                    if (activeButton.length !== 1)
                                        valid = false;
                                    if (pwdBox.is(":visible")) {
                                        if (!pwdBox.val()) {
                                            pwdBox.addClass("mandatory");
                                            valid = false;
                                        }
                                        else
                                            pwdBox.removeClass("mandatory");
                                    }
                                    if (reasonBox.is(":visible")) {
                                        if (!reasonBox.val()) {
                                            reasonBox.addClass("mandatory");
                                            valid = false;
                                        }
                                        else
                                            reasonBox.removeClass("mandatory");
                                    }
                                    return valid;
                                };
                                // Enables/disables the OK button based on required fields
                                const updateOKButton = function (evt) {
                                    if (validate())
                                        $("#" + configData.okButtonId).prop("disabled", false);
                                    else
                                        $("#" + configData.okButtonId).prop("disabled", true);
                                };
                                const onPwdBoxChange = function (evt) {
                                    updateOKButton();
                                    if (validate() && evt && evt.keyCode === 13)
                                        okButtonClicked();
                                };
                                const resizeHeight = function (pwd, statement, reason) {
                                    let textPaneHeight = 0;
                                    let messageDivHeight = 0;
                                    let windowHeight = 5.3625 + choiceListHeight;
                                    $("#" + configData.messageDiv).height("auto");
                                    if (pwd)
                                        textPaneHeight = textPaneHeight + 4.6125;
                                    if (statement)
                                        textPaneHeight = textPaneHeight + 5.4375;
                                    messageDivHeight = $("#" + configData.messageDiv).height() / parseFloat($("body").css("font-size"));
                                    windowHeight = windowHeight + textPaneHeight + messageDivHeight + 0.9;
                                    $(".k-widget.k-window").height(windowHeight + "em");
                                    $("#" + configData.textPaneId).height(textPaneHeight + "em");
                                    $("#" + configData.textPaneId).resize();
                                    $("#" + configData.infoPaneId).height(messageDivHeight + "em");
                                    $("#" + configData.infoPaneId).resize();
                                    $("#" + configData.messageDiv).resize();
                                    $("#" + configData.messageIconDiv).height(messageDivHeight + "em");
                                    $("#" + configData.messageIconDiv).resize();
                                    $("#" + configData.choicePaneId).height(messageDivHeight + choiceListHeight + "em");
                                    $("#" + configData.choicePaneId).resize();
                                    $("#" + configData.splitterId).height(textPaneHeight + messageDivHeight + choiceListHeight + "em");
                                    $("#" + configData.splitterId).resize();
                                };
                                // Based on the choice options, disables/enables the fields necessary for the choice
                                const updateOptions = function (elem) {
                                    $("#" + configData.okButtonId).focus();
                                    const options = elem.data("choiceOptions");
                                    if (options.auth === "pwd") {
                                        pwdSizedIn = true;
                                        $("#" + configData.pwdLabelDiv).show();
                                        $("#" + configData.pwdTextBoxDiv).show().find("input.k-textbox").focus();
                                    }
                                    else {
                                        pwdSizedIn = false;
                                        $("#" + configData.pwdLabelDiv).hide();
                                        $("#" + configData.pwdTextBoxDiv).hide();
                                    }
                                    if (options.statement) {
                                        statementSizedIn = true;
                                        $("#" + configData.textPaneId).show();
                                        $("#" + configData.reasonLabelDiv).show();
                                        $("#" + configData.reasonTextBoxDiv).show().find("textarea.k-textbox").focus();
                                    }
                                    else {
                                        statementSizedIn = false;
                                        $("#" + configData.reasonLabelDiv).hide();
                                        $("#" + configData.reasonTextBoxDiv).hide();
                                    }
                                    if (options.reason) {
                                        reasonSizedIn = true;
                                        $("#" + configData.infoPaneId).show();
                                        $("#" + configData.messageDiv).html(kendo.htmlEncode(options.reason)).show();
                                        $("#" + configData.messageIconDiv).show();
                                    }
                                    else {
                                        reasonSizedIn = false;
                                        $("#" + configData.infoPaneId).hide();
                                        $("#" + configData.messageDiv).hide();
                                        $("#" + configData.messageIconDiv).hide();
                                    }
                                    resizeHeight(pwdSizedIn, statementSizedIn, reasonSizedIn);
                                };
                                // Attach event handlers
                                $("#" + configData.pwdTextBoxId).keyup(onPwdBoxChange).change(onPwdBoxChange);
                                $("#" + configData.reasonTextBoxId).keyup(updateOKButton).change(updateOKButton);
                                $("#" + configData.choiceContainer).find("button.choiceButton").on('click', function () {
                                    $("#" + configData.choiceContainer).find("button.choiceButton").removeClass("active");
                                    $(this).addClass("active");
                                    updateOptions($(this));
                                    updateOKButton();
                                    const focusDOM = $(":focus").length ? $(":focus")[0] : undefined;
                                    if (!focusDOM || !$.contains(document.getElementById(configData.windowID), focusDOM)) {
                                        // Focus OK button if no element of dialog is focused
                                        $("#" + configData.okButtonId).focus();
                                    }
                                });
                                const buttons = windowData.contentDiv.find("button.choiceButton");
                                // There might only be one option. Select it automatically
                                if (buttons.length === 1)
                                    buttons.addClass("active").trigger("click");
                                // Choice may be pre-selected by options parameter!
                                else if (options && options.selectedOption) {
                                    windowData.contentDiv
                                        .find("button.choiceButton[id='choice_" + options.selectedOption + "']")
                                        .addClass("active")
                                        .trigger("click");
                                }
                                else if (options && options["cemanagsys.29selectedchoicecid"]) {
                                    const choiceId = options["cemanagsys.29selectedchoicecid"];
                                    for (let j = 0; j < buttons.length; j++) {
                                        const elem = $(buttons[j]);
                                        const curId = parseInt(elem.attr("id").split("_")[1], 10);
                                        if ((choiceId === "sign" && curId > 999 && curId < 2000)
                                            || (choiceId === "reject" && curId > 1999 && curId < 3000)) {
                                            elem.addClass("active").trigger("click");
                                            break;
                                        }
                                    }
                                }
                                $("#" + configData.cancelButtonId).on('click', function () {
                                    if (typeof window.synDesktopApp !== "undefined")
                                        window.synDesktopApp.endDialog("0");
                                    else
                                        $("#" + configData.windowID).data("kendoWindow").close();
                                });
                                // OK button click handler
                                const okButtonClicked = function () {
                                    if ($("#" + configData.okButtonId).is("[disabled]"))
                                        return false;
                                    const selectedButton = $("button.choiceButton.active");
                                    if (selectedButton.length !== 1)
                                        return false;
                                    // Selected option
                                    const selectedVal = selectedButton.data("choiceOptions").id.toString();
                                    // Password, if present
                                    const pwd = $("#" + configData.pwdTextBoxId).val();
                                    // Reason, if present
                                    const reason = $("#" + configData.reasonTextBoxId).val();
                                    if (typeof window.synDesktopApp !== "undefined") {
                                        const dlgResult = encodeURIComponent(selectedVal)
                                            + "|" + encodeURIComponent(pwd)
                                            + "|" + encodeURIComponent(reason);
                                        window.synDesktopApp.set_resultValue(dlgResult);
                                        window.synDesktopApp.endDialog("1");
                                    }
                                    else {
                                        Utilities_1.synUtil.beginAjaxProgress("#" + configData.okButtonId);
                                        // Create JSON data for calling cemanagsys.29
                                        const dataObj = { "cemanagsys.29selectedchoicecid": selectedVal, bestid: undefined };
                                        if (pwd)
                                            dataObj["cemanagsys.29pwd"] = pwd;
                                        if (reason)
                                            dataObj["cemanagsys.29choicestatement"] = reason;
                                        if (options && options.confObjectId)
                                            dataObj.bestid = options.confObjectId;
                                        Utilities_1.synUtil.executeMethod({
                                            method: "cemanagsys.29",
                                            ids,
                                            parentId,
                                            relId,
                                            additionalData: dataObj,
                                            done(dataJSON) {
                                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                    // PDF stamping might be necessary => Workspace
                                                    let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                                    const containerId = data.additionalInformation.sigworkspacecontainerid;
                                                    if (containerId) {
                                                        if (Utilities_1.synUtil.useSynerisWorkspace) {
                                                            Utilities_1.synUtil.beginAjaxProgress("#" + configData.okButtonId);
                                                            Utilities_1.synUtil.openWorkspace("synerisws" + instanzId + "://common/stamppdfs/" + containerId + "/" + instanzId);
                                                            const deleteFromFileCache = function (containerId) {
                                                                Utilities_1.synUtil.getAJAXData({
                                                                    url: "WSProxy.axd?cache=FileCache/" + containerId + "/",
                                                                    method: "DELETE",
                                                                    fail() {
                                                                        "Method not implemented.";
                                                                    }
                                                                });
                                                            };
                                                            const poll = function (timeout) {
                                                                setTimeout(function () {
                                                                    Utilities_1.synUtil.getAJAXData({
                                                                        url: "WSProxy.axd?cache=FileCache/" + containerId + "/StampInfo",
                                                                        done(data) {
                                                                            if (data.done) {
                                                                                deleteFromFileCache(containerId);
                                                                                $("#" + configData.windowID).data("kendoWindow").close();
                                                                                if (completedHandler)
                                                                                    completedHandler(true);
                                                                            }
                                                                            else if (data.error) {
                                                                                $.errorDialog(data.error);
                                                                                deleteFromFileCache(containerId);
                                                                                $("#" + configData.windowID).data("kendoWindow").close();
                                                                                if (completedHandler)
                                                                                    completedHandler(false);
                                                                            }
                                                                            else if (windowClosed) {
                                                                                deleteFromFileCache(containerId);
                                                                                if (completedHandler)
                                                                                    completedHandler(false);
                                                                            }
                                                                            else
                                                                                poll(2000);
                                                                        },
                                                                        fail() {
                                                                            $("#" + configData.windowID).data("kendoWindow").close();
                                                                            if (completedHandler)
                                                                                completedHandler(false);
                                                                        }
                                                                    });
                                                                }, timeout);
                                                            };
                                                            poll(5000);
                                                        }
                                                        else
                                                            $.errorDialog({
                                                                ErrorDisplayMessage: Utilities_1.synUtil.Strings.getValue("installworkspace", "Please install and activate syneris Workspace")
                                                            });
                                                    }
                                                    else {
                                                        $("#" + configData.windowID).data("kendoWindow").close();
                                                        if (completedHandler)
                                                            completedHandler(true);
                                                    }
                                                });
                                            },
                                            cleanUp() {
                                                Utilities_1.synUtil.endAjaxProgress("#" + configData.okButtonId);
                                            }
                                        });
                                    }
                                };
                                // Register OK button click handler
                                $("#" + configData.okButtonId).on('click', okButtonClicked);
                            });
                        });
                    }
                });
            }
        },
        "32": {
            impl(ids, parentId, relId, completedHandler, options) {
                const opts = { "cemanagsys.29selectedchoicecid": "sign" };
                exports.synerisMethods.cemanagsys["29"].impl(ids, parentId, relId, completedHandler, opts);
            }
        },
        "33": {
            impl(ids, parentId, relId, completedHandler, options) {
                const opts = { "cemanagsys.29selectedchoicecid": "reject" };
                exports.synerisMethods.cemanagsys["29"].impl(ids, parentId, relId, completedHandler, opts);
            }
        }
    },
    mailext: {
        // send mail
        "27": {
            selCount: 1,
            impl(ids, parentId, relId, completedHandler) {
                if (ids && ids.length === 1) {
                    Utilities_1.synUtil.executeMethod({
                        method: "mailext.27",
                        additionalData: { "mailext.27action": "config" },
                        ids,
                        parentId,
                        relId,
                        done(dataJSON) {
                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                let result = JSON.parse(data.additionalInformation["mailext.27result"]);
                                const keepSignature = result.keepSignature;
                                if (result.gui) {
                                    const templateMarkup = require("../../templates/mailext_27.tmpl.html");
                                    const action = Utilities_1.synUtil.Strings.getValue("mailext.27");
                                    const windowData = Utilities_1.synUtil.popupWindow({
                                        title: action, width: 340, height: 210,
                                        modal: true
                                    });
                                    const windowid = "popup_" + windowData.guid;
                                    const cancelButtonID = "cancelButton_" + windowData.guid;
                                    const data = {
                                        synUtil: Utilities_1.synUtil,
                                        windowID: windowid,
                                        cancelButtonID,
                                        buttonID: "button_" + windowData.guid,
                                        buttonText: kendo.htmlEncode(action),
                                        contentTypesName: result.stringContent,
                                        contentLinkIdsName: result.stringSend,
                                        sendRelDocsName: result.stringAttachment,
                                        contentTypesDropDownID: "contentTypesDropDown_" + windowData.guid,
                                        contentLinkIdsDropDownID: "contentLinkIdsDropDown_" + windowData.guid,
                                        sendRelDocsCheckboxID: "sendRelDocsCheckbox_" + windowData.guid
                                    };
                                    // Create HTML from template
                                    const template = kendo.template(templateMarkup);
                                    windowData.contentDiv.html(template(data));
                                    const $contentTypeDropdown = windowData.contentDiv.find("#" + data.contentTypesDropDownID);
                                    const $linkIdDropdown = windowData.contentDiv.find("#" + data.contentLinkIdsDropDownID);
                                    const $sendRelDocsCheckbox = windowData.contentDiv.find("#" + data.sendRelDocsCheckboxID);
                                    $contentTypeDropdown.kendoDropDownList({
                                        noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
                                        autoBind: true,
                                        dataTextField: "value",
                                        dataValueField: "id",
                                        dataSource: result.contentTypes
                                    });
                                    $linkIdDropdown.kendoDropDownList({
                                        noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
                                        autoBind: true,
                                        dataTextField: "name",
                                        dataValueField: "id",
                                        dataSource: result.contentLinkIds,
                                        change(e) {
                                            const sel = this.dataItem(this.select());
                                            if (sel.id === 1)
                                                $contentTypeDropdown.data("kendoDropDownList").enable(false);
                                            else
                                                $contentTypeDropdown.data("kendoDropDownList").enable(true);
                                        }
                                    });
                                    $("#" + data.buttonID).on('click', function () {
                                        const dataObj = {
                                            "mailext.27action": "check",
                                            "mailext.27contentType": $contentTypeDropdown.val(),
                                            "mailext.27contentLinkId": $linkIdDropdown.val(),
                                            "mailext.27sendRelDocs": "" + $sendRelDocsCheckbox.prop("checked")
                                        };
                                        Utilities_1.synUtil.executeMethod({
                                            method: "mailext.27",
                                            ids,
                                            parentId,
                                            relId,
                                            done(dataJSON) {
                                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                    let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                                    $("#" + windowid).data("kendoWindow").close();
                                                    result = JSON.parse(data.additionalInformation["mailext.27result"]);
                                                    const resultText = result.checkedoutdocs != undefined ? result.checkedoutdocs.toString().replace(",", "\n") : "";
                                                    const confirmText = Utilities_1.synUtil.Strings.getValue("mailext27warncheckedoutdocstext").replace(/\\n/g, "\n") + "\n" + resultText;
                                                    if (result.checkedoutdocs != undefined && (result.checkedoutdocs.length === 0 || (result.checkedoutdocs.length > 0 && window.confirm(confirmText)))) {
                                                        const dataObj = {
                                                            "mailext.27action": "exec",
                                                            "mailext.27contentType": $contentTypeDropdown.val(),
                                                            "mailext.27contentLinkId": $linkIdDropdown.val(),
                                                            "mailext.27sendRelDocs": "" + $sendRelDocsCheckbox.prop("checked")
                                                        };
                                                        Utilities_1.synUtil.executeMethod({
                                                            method: "mailext.27",
                                                            ids,
                                                            parentId,
                                                            relId,
                                                            done(dataJSON) {
                                                                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                                    let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                                                    result = JSON.parse(data.additionalInformation["mailext.27result"]);
                                                                    if (result.gui) {
                                                                        Utilities_1.synUtil.openWorkspace("synerisws" + result.instanceId + "://common/sendemailwithoutlook/" + result.instanceId + "/" + result.cacheId + "/" + keepSignature);
                                                                        if (completedHandler)
                                                                            completedHandler(true);
                                                                    }
                                                                    else {
                                                                        if (completedHandler)
                                                                            completedHandler(false);
                                                                    }
                                                                });
                                                            },
                                                            additionalData: dataObj
                                                        });
                                                    }
                                                    else {
                                                        if (completedHandler)
                                                            completedHandler(false);
                                                    }
                                                });
                                            },
                                            additionalData: dataObj
                                        });
                                    });
                                    $("#" + cancelButtonID).on('click', function () {
                                        $("#" + windowid).data("kendoWindow").close();
                                    });
                                }
                                else {
                                    Utilities_1.synUtil.executeMethod({
                                        method: "mailext.27",
                                        additionalData: { "mailext.27action": "exec" },
                                        ids,
                                        parentId,
                                        relId,
                                        done(dataJSON) {
                                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                                result = JSON.parse(data.additionalInformation["mailext.27result"]);
                                                if (result.gui) {
                                                    Utilities_1.synUtil.openWorkspace("synerisws" + result.instanceId + "://common/sendemailwithoutlook/" + result.instanceId + "/" + result.cacheId + "/" + keepSignature);
                                                    if (completedHandler)
                                                        completedHandler(false);
                                                }
                                                else {
                                                    if (completedHandler)
                                                        completedHandler(true);
                                                }
                                            });
                                        },
                                    });
                                }
                            });
                        }
                    });
                }
            }
        },
    },
    synconvertext: {
        // Lokales Drucken (PDF)
        "3": {
            selCount: -2,
            impl(ids, parentId, relId, completedHandler) {
                if (ids && ids.length) {
                    const guid = Utilities_1.synUtil.getGUID();
                    Utilities_1.synUtil.beginAjaxProgress();
                    Utilities_1.synUtil.executeMethod({
                        method: "synconvertext.2",
                        ids,
                        parentId,
                        relId,
                        done(resultDataJSON) {
                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                let resultData = yield MethodServerResponse_1.MethodServerResponse.fromJSON(resultDataJSON);
                                if ("Y" === resultData.additionalInformation.pdfexists) {
                                    Utilities_1.synUtil.getAJAXData({
                                        url: Utilities_1.synUtil.getWSUrl("ContentTempDownloadable") + guid,
                                        done(downloadable) {
                                            $.fileDownload(Utilities_1.synUtil.getWSUrl("ContentTempDownload") + guid
                                                + "?forceAttachment=true&csrfToken=" + Utilities_1.synUtil.requestVerificationToken);
                                        }
                                    });
                                }
                                else {
                                    Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("nopdfcontents", "Es konnten keine PDF-Inhalte gefunden werden!"));
                                }
                            });
                        },
                        cleanUp() {
                            Utilities_1.synUtil.endAjaxProgress();
                        },
                        additionalData: {
                            tempPathGUID: guid,
                            tempPathTarget: "synconvertext.2resultfilepath",
                            ignorepdfsec: true
                        }
                    });
                }
            }
        },
    },
    synnotificationext: {
        // Notifications dialog
        "1": {
            impl(ids, parentId, relId, completedHandler) {
                require.ensure(["../../templates/synnotificationext_1.less"], (require) => {
                    const synnotificationext_1_less = require("../../templates/synnotificationext_1.less");
                    const notificationExtMarkup = require("../../templates/synnotificationext_1.tmpl.html");
                    const windowData = Utilities_1.synUtil.popupWindow({
                        title: Utilities_1.synUtil.Strings.getValue("synnotificationext.1"),
                        width: 800,
                        height: 600,
                        modal: true,
                        synDesktopAware: true
                    });
                    const idData = {
                        windowID: "popup_" + windowData.guid,
                        splitterId: "splitter_" + windowData.guid,
                        notificationListId: "notificationList_" + windowData.guid,
                        messagePaneId: "messagePane_" + windowData.guid,
                        messageContainerId: "messageContainer_" + windowData.guid
                    };
                    // Create HTML from template
                    const template = kendo.template(notificationExtMarkup);
                    $(windowData.windowDiv).css("height", "100%");
                    windowData.contentDiv.html(template(idData));
                    // Splitter
                    const splitter = $("#" + idData.splitterId).kendoSplitter({
                        orientation: "vertical",
                        panes: [{
                                size: "50%",
                                scrollable: true,
                                resizable: true
                            }, {
                                scrollable: true,
                                collapsible: true,
                                collapsed: true
                            }]
                    }).data("kendoSplitter");
                    // Headers listview
                    $("#" + idData.notificationListId).kendoListView({
                        dataSource: new kendo.data.DataSource({
                            transport: {
                                read(options) {
                                    Utilities_1.synUtil.executeMethod({
                                        method: "synnotificationext.6",
                                        done(dataJSON) {
                                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                // Warning for copy&modify: virualFields must NOT be used in new applications!
                                                let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON, [
                                                    "notifications.id",
                                                    "notifications.senderid",
                                                    "notifications.from",
                                                    "notifications.sourceid",
                                                    "notifications.sourcetype",
                                                    "notifications.createdate",
                                                    "notifications.subject",
                                                    "notifications.msgbody",
                                                    "notifications.userid",
                                                    "notifications.readdate",
                                                    "notifications.validfrom",
                                                    "notifications.validto",
                                                    "notifications.archiveperiod"
                                                ]);
                                                const result = [];
                                                if (data.readObjects) {
                                                    $.each(data.readObjects, function (idx, elem) {
                                                        var _a;
                                                        result.push({
                                                            id: elem.items["notifications.id"].valueAsString,
                                                            read: ((_a = elem.items["notifications.readdate"]) === null || _a === void 0 ? void 0 : _a.value) != undefined,
                                                            header: elem.items["notifications.subject"].valueAsString,
                                                            from: elem.items["notifications.from"].valueAsString,
                                                            date: elem.items["notifications.validfrom"].valueAsDate
                                                        });
                                                    });
                                                    result.sort(function (a, b) {
                                                        return a.date < b.date ? 1 : a.date === b.date ? 0 : -1;
                                                    });
                                                }
                                                options.success(result);
                                            });
                                        }
                                    });
                                }
                            }
                        }),
                        template: "<div class='msgHeader#= (read? \"\": \" unread\") #'><div class='header'><i class='fa fa-star'></i>#:header #</div><div class='from'>#:from #, </div><div class='date'>#= kendo.toString(date, 'G')#</div></div>",
                        selectable: "single",
                        change(e) {
                            splitter.expand($("#" + idData.messagePaneId));
                            const lv = $("#" + idData.notificationListId).data("kendoListView");
                            const dataItem = lv.dataItem(lv.select());
                            Utilities_1.synUtil.executeMethod({
                                method: "synnotificationext.7",
                                additionalData: { "synnotificationext.7id": dataItem.id },
                                done(dataJSON) {
                                    var _a;
                                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                        let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                        if (data.readObjects && data.readObjects.length === 1) {
                                            $("#" + idData.messageContainerId).html(data.readObjects[0].items["notifications.msgbody"].valueAsString);
                                            if (((_a = data.readObjects[0].items["notifications.readdate"]) === null || _a === void 0 ? void 0 : _a.value) == undefined) {
                                                Utilities_1.synUtil.executeMethod({
                                                    method: "synnotificationext.8",
                                                    additionalData: { "synnotificationext.8id": dataItem.id },
                                                    done(data2) {
                                                        if (typeof window.synDesktopApp === "undefined") {
                                                            /* $("#footer").synFooter("showNotifications", {
                                                                read: parseInt(data2.additionalInformation["synnotificationext.8read"], 10),
                                                                unread: parseInt(data2.additionalInformation["synnotificationext.8unread"], 10)
                                                            });*/
                                                        }
                                                        else {
                                                            Utilities_1.synUtil.executeDesktopMethod("synnotificationext.8", {
                                                                additionalData: { "synnotificationext.8id": dataItem.id }
                                                            });
                                                        }
                                                        $("#" + idData.notificationListId).data("kendoListView").dataSource.read();
                                                    }
                                                });
                                            }
                                        }
                                        else
                                            $("#" + idData.messageContainerId).html("");
                                    });
                                }
                            });
                        },
                        dataBound() {
                            const lv = $("#" + idData.notificationListId).data("kendoListView");
                            if (!lv.dataSource.data().length) {
                                Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("notification.nonotifications"));
                                $("#" + windowData.windowID).data("kendoWindow").close();
                            }
                        }
                    });
                });
            }
        }
    },
    syntemplateext: {
        // Vorlage hinzufügen/ersetzen
        "2": {
            selCount: 1,
            impl(ids, parentId, relId, completedHandler) {
                if (ids && ids.length === 1) {
                    Utilities_1.synUtil.executeMethod({
                        method: "syntemplateext.2",
                        additionalData: { "syntemplateext.2action": "check" },
                        ids,
                        parentId,
                        relId,
                        done(dataJSON) {
                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                let cont = false;
                                if ("N" !== data.additionalInformation["syntemplateext.2hascontent"]) {
                                    cont = window.confirm(data.additionalInformation["syntemplateext.2ask"]);
                                }
                                else
                                    cont = true;
                                if (cont) {
                                    const action = Utilities_1.synUtil.Strings.getValue("syntemplateext.2");
                                    const windowData = Utilities_1.synUtil.popupWindow({
                                        title: action,
                                        width: 600,
                                        height: 400,
                                        modal: true
                                    });
                                    windowData.contentDiv
                                        .on("initSuccess", function () {
                                        windowData.contentDiv.find(".k-widget.k-dropdown").css("width", "100%");
                                        windowData.contentDiv.synTemplates("setCategory", parseInt(ids[0].split("|")[2], 10));
                                        const buttonDiv = $("<div style='position: absolute; bottom: 0; right: 0; padding-bottom: 10px; padding-right: 10px; '></div>")
                                            .appendTo(windowData.contentDiv);
                                        const closeWindow = function () {
                                            windowData.contentDiv.synTemplates("destroy");
                                            $("#" + windowData.windowID).data("kendoWindow").close();
                                        };
                                        const okButton = $("<button type='button' id='okButton_" + windowData.guid + "'class='k-button'>" + kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("menuok", "OK")) + "</button>")
                                            .appendTo(buttonDiv)
                                            .on('click', function () {
                                            Utilities_1.synUtil.beginAjaxProgress("#okButton_" + windowData.guid);
                                            const templateID = windowData.contentDiv.synTemplates("getSelectedTemplateId");
                                            Utilities_1.synUtil.executeMethod({
                                                method: "syntemplateext.2",
                                                additionalData: { "syntemplateext.2templateid": templateID },
                                                ids,
                                                parentId,
                                                relId,
                                                done(data) {
                                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("contentreplaced", "Inhalt wurde hinzugefügt/ersetzt"));
                                                    if (completedHandler)
                                                        completedHandler(false);
                                                    closeWindow();
                                                },
                                                cleanUp() {
                                                    Utilities_1.synUtil.endAjaxProgress("#okButton_" + windowData.guid);
                                                }
                                            });
                                        });
                                        Utilities_1.synUtil.toggleEnabledState(okButton, false);
                                        const cancelButton = $("<button type='button' class='k-button'>" + kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("menucancel") || "Cancel") + "</button>")
                                            .appendTo(buttonDiv)
                                            .on('click', function () {
                                            closeWindow();
                                        });
                                        // .find(".k-widget.k-dropdown").css("width", "100%");
                                    })
                                        .on("templateSelected", function () {
                                        Utilities_1.synUtil.toggleEnabledState($("#okButton_" + windowData.guid), true);
                                    })
                                        .on("templateUnselected", function () {
                                        Utilities_1.synUtil.toggleEnabledState($("#okButton_" + windowData.guid), false);
                                    }).on("prodSysDataLoaded", function () {
                                        const proddefId = data.modifications.modifiedInstances[0]["ceproddef.id"].value;
                                        if (proddefId) {
                                            windowData.contentDiv.data("synTemplates").prodSysDropDown.select(function (dataItem) {
                                                return dataItem.id === proddefId;
                                            });
                                        }
                                        if (windowData.contentDiv.data("synTemplates").prodSysDropDown.dataSource.data().length === 0) {
                                            Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("conedtnotemplate"));
                                        }
                                    })
                                        .synTemplates();
                                }
                            });
                        }
                    });
                }
            }
        },
    },
    synworkflowext: {
        // Auswahldialog für Bestätigungsobjekte anzeigen
        "9": {
            impl(ids, parentId, relId, completedHandler) {
                Utilities_1.synUtil.executeMethod({
                    method: "synworkflowext.9",
                    ids,
                    done(dataJSON) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                            let choicelist;
                            const windowWidth = 460;
                            let windowHeight = 235;
                            if (data.additionalInformation["synworkflowext.9choicelist"]) {
                                choicelist = JSON.parse(data.additionalInformation["synworkflowext.9choicelist"]);
                                windowHeight = 150 + 20 * choicelist.length + 30 + 100;
                            }
                            const templateMarkup = require("../../templates/synworkflowext_9.tmpl.html");
                            const action = Utilities_1.synUtil.Strings.getValue("synworkflowext.9");
                            const options = { title: action, width: windowWidth, height: windowHeight, modal: false, resizable: true };
                            const windowData = Utilities_1.synUtil.popupWindow(options);
                            const windowid = "popup_" + windowData.guid;
                            let data2 = {
                                windowID: "popup_" + windowData.guid,
                                buttonID: "button_" + windowData.guid,
                                choicelist
                            };
                            // Create HTML from template
                            const template = kendo.template(templateMarkup);
                            windowData.contentDiv.html(template(data2));
                            $("#" + data2.buttonID).on('click', function () {
                                const dataObj = {
                                    "synworkflowext.9selectedchoicecid": $("input[name=choice]:checked").val(),
                                    "synworkflowext.9choicereason": $("textarea[name=reason]").val()
                                };
                                Utilities_1.synUtil.executeMethod({
                                    method: "synworkflowext.9",
                                    ids,
                                    parentId,
                                    relId,
                                    done() {
                                        Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("ackobjectsent"));
                                        $("#" + windowid).data("kendoWindow").close();
                                        if (completedHandler)
                                            completedHandler(false);
                                    },
                                    additionalData: dataObj
                                });
                            });
                        });
                    },
                    additionalData: { "synworkflowext.9action": "config" }
                });
            }
        },
        // Auswahldialog für Workflow-Templates anzeigen
        "11": {
            impl(ids, parentId, relId, completedHandler) {
                Utilities_1.synUtil.executeMethod({
                    method: "synworkflowext.11",
                    ids,
                    done(dataJSON) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                            const result = data.additionalInformation["synworkflowext.11result"];
                            switch (result) {
                                case "wfexists":
                                    Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("workflowalreadyexists", "Zu diesem Objekt gibt es bereits einen aktiven Workflow"));
                                    break;
                                case "nowft":
                                    Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("noworkflowtemplatedefined", "Für dieses Objekt wurden keine Workflow-Templates festgelegt"));
                                    break;
                                // case "ok":
                                default:
                                    let workflowtemplatelist;
                                    if (data.additionalInformation["synworkflowext.11workflowtemplatelist"]) {
                                        workflowtemplatelist =
                                            JSON.parse(data.additionalInformation["synworkflowext.11workflowtemplatelist"])
                                                .sort(function (a, b) {
                                                if (a.name < b.name)
                                                    return -1;
                                                else if (a.name === b.name)
                                                    return 0;
                                                return 1;
                                            });
                                    }
                                    for (const prop in workflowtemplatelist) {
                                        const item = workflowtemplatelist[prop];
                                        if (item.active === "true")
                                            item.name += " " + Utilities_1.synUtil.Strings.getValue("activeworkflow", "(Active workflow)");
                                    }
                                    const allowOneWorkflowPerTemplate = data.additionalInformation["synworkflowext.11allowoneworkflowpertemplate"];
                                    const templateMarkup = require("../../templates/synworkflowext_11.tmpl.html");
                                    const action = Utilities_1.synUtil.Strings.getValue("synworkflowext.11");
                                    const windowData = Utilities_1.synUtil.popupWindow({
                                        title: Utilities_1.synUtil.Strings.getValue("chooseworkflowtemplate"),
                                        width: 600,
                                        height: 325,
                                        resizable: false,
                                        modal: true,
                                        synDesktopAware: true
                                    });
                                    const windowid = "popup_" + windowData.guid;
                                    const dataObj = {
                                        synUtil: Utilities_1.synUtil,
                                        buttonText: kendo.htmlEncode(action),
                                        windowID: "popup_" + windowData.guid,
                                        cancelButtonId: "cancelButtonId_" + windowData.guid,
                                        okButtonId: "okButtonId_" + windowData.guid,
                                        listView: "listView_" + windowData.guid,
                                        contentDiv: "contentDiv_" + windowData.guid,
                                        addTextDiv: "addTextDiv_" + windowData.guid,
                                        addText: Utilities_1.synUtil.Strings.getValue("allowoneworkflowpertemplate", "Please choose a workflow template, where there is no active workflow yet"),
                                        additionalInformation: undefined
                                    };
                                    if (allowOneWorkflowPerTemplate === "false")
                                        dataObj.addText = "";
                                    $(windowData.windowDiv).css("height", "100%");
                                    let selectedWorkflowTemplateId;
                                    // Create HTML from template
                                    const template = kendo.template(templateMarkup);
                                    windowData.contentDiv.html(template(dataObj));
                                    // Splitter
                                    $("#" + dataObj.contentDiv)
                                        .kendoSplitter({
                                        orientation: "vertical",
                                        panes: [{}, { size: "50px", scrollable: false, resizable: false }]
                                    });
                                    windowData.contentDiv.find(".k-splitbar-vertical").hide();
                                    $("#" + dataObj.listView).kendoListView({
                                        dataSource: workflowtemplatelist,
                                        template: "<div class='listViewElem'>#=name #</div>",
                                        selectable: "single",
                                        change(e) {
                                            const index = this.select().index();
                                            const item = this.dataSource.at(index);
                                            selectedWorkflowTemplateId = item.id.toString();
                                            if (item.active === "true")
                                                $("#" + dataObj.okButtonId).attr("disabled", "disabled");
                                            else
                                                $("#" + dataObj.okButtonId).removeAttr("disabled");
                                        }
                                    });
                                    // Cancel button click event
                                    $("#" + dataObj.cancelButtonId).on('click', function () {
                                        if (typeof window.synDesktopApp !== "undefined")
                                            window.synDesktopApp.endDialog("0");
                                        else
                                            $("#" + dataObj.windowID).data("kendoWindow").close();
                                    });
                                    // OK button click event
                                    $("#" + dataObj.okButtonId).on('click', function () {
                                        if (typeof window.synDesktopApp !== "undefined") {
                                            window.synDesktopApp.set_resultValue(selectedWorkflowTemplateId);
                                            window.synDesktopApp.endDialog("1");
                                        }
                                        else {
                                            Utilities_1.synUtil.beginAjaxProgress("#" + dataObj.okButtonId);
                                            const dataObj2 = {
                                                "synworkflowext.11selectedworkflowtemplateid": selectedWorkflowTemplateId
                                            };
                                            Utilities_1.synUtil.executeMethod({
                                                method: "synworkflowext.11",
                                                ids,
                                                parentId,
                                                relId,
                                                done(dataJSON) {
                                                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                                        let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                                                        if (data.additionalInformation["synworkflowext.11notnullfields"]) {
                                                            $("#" + windowid).data("kendoWindow").close();
                                                            const result = JSON.parse(data.additionalInformation["synworkflowext.11notnullfields"]);
                                                            const message = Utilities_1.synUtil.Strings.getValue("synworkflowext11.notnullfieldsmsg");
                                                            alert(message + " " + result.notnullfields.toString());
                                                            if (completedHandler)
                                                                completedHandler(false);
                                                        }
                                                        else {
                                                            if (selectedWorkflowTemplateId) {
                                                                Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("workflowcreated"));
                                                                $("#" + windowid).data("kendoWindow").close();
                                                                if (completedHandler)
                                                                    completedHandler(false);
                                                            }
                                                        }
                                                    });
                                                },
                                                fail(jqXHR, textStatus, errorThrown, url) {
                                                    $("#" + windowData.windowID).data("kendoWindow").close();
                                                    Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                                                },
                                                cleanUp() {
                                                    Utilities_1.synUtil.endAjaxProgress("#" + dataObj.okButtonId);
                                                },
                                                additionalData: dataObj2
                                            });
                                        }
                                    });
                                    break;
                            }
                        });
                    },
                    fail(jqXHR, textStatus, errorThrown, url) {
                        Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                    },
                    additionalData: { "synworkflowext.11action": "config" }
                });
            }
        },
        // Show GUI of passed workflow object, if active node is a GUI activity
        "16": {
            impl(ids, parentId, relId, completedHandler, options) {
                const wsurl = Utilities_1.synUtil.getWSUrl("GetChecklistInstanceFromWorkflowNode") + ids[0] + "/" + options.workflowNodeId + "/" + options.workflowThreadId;
                Utilities_1.synUtil.getAJAXData({
                    url: wsurl,
                    dataType: "json",
                    done(data) {
                        const markup = require("../../templates/workflowgui.tmpl.html");
                        // Create Window
                        const windowData = Utilities_1.synUtil.popupWindow({
                            title: data.workflowNodeName,
                            actions: ["Maximize", "Close"],
                            width: 1024,
                            height: 768,
                            resizable: true,
                            modal: true,
                            synDesktopAware: true
                        });
                        // Initialize contents
                        const configData = {
                            synUtil: Utilities_1.synUtil,
                            windowID: "popup_" + windowData.guid,
                            checklistId: "checklist_" + windowData.guid,
                            saveButtonId: "saveButton_" + windowData.guid,
                            savecloseButtonId: "savecloseButton_" + windowData.guid,
                            cancelButtonId: "cancelButton_" + windowData.guid,
                        };
                        // Create HTML from template
                        const template = kendo.template(markup);
                        windowData.contentDiv.html(template(configData));
                        const checklistPane = $("#" + configData.checklistId);
                        checklistPane.synChecklist();
                        // If values can not be saved to gui (checklist), hide save button
                        if (!data.writeValuesToGUI)
                            $("#" + configData.saveButtonId).css("display", "none");
                        const saveInstance = function (exec, callback) {
                            const newChecklistInstance = checklistPane.synChecklist("getInstance");
                            const requestOptions = {
                                execWorkflow: exec,
                                workflowId: ids[0],
                                workflowNodeId: data.workflowNodeId,
                                workflowThreadId: options.workflowThreadId,
                                checklistInstance: JSON.stringify(newChecklistInstance)
                            };
                            Utilities_1.synUtil.getAJAXData({
                                method: "POST",
                                url: Utilities_1.synUtil.getWSUrl("SetWorkflowNodeFromChecklistInstance"),
                                dataType: "json",
                                requestData: requestOptions,
                                done() {
                                    Utilities_1.synUtil.Notifications.menuSuccess("synworkflowext.16");
                                    if (typeof window.synDesktopApp !== "undefined")
                                        window.synDesktopApp.endDialog("0");
                                    else
                                        $("#" + configData.windowID).data("kendoWindow").close();
                                    callback();
                                },
                                fail(jqXHR, textStatus, errorThrown, url) {
                                    Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                                }
                            });
                        };
                        $("#" + configData.saveButtonId).on('click', function () {
                            saveInstance(false, function () {
                                if (options.closeWindow)
                                    window.close();
                            });
                        });
                        $("#" + configData.savecloseButtonId).on('click', function () {
                            saveInstance(true, function () {
                                if (options.closeWindow)
                                    window.close();
                            });
                        });
                        $("#" + configData.cancelButtonId).on('click', function () {
                            if (typeof window.synDesktopApp !== "undefined")
                                window.synDesktopApp.endDialog("0");
                            else
                                $("#" + configData.windowID).data("kendoWindow").close();
                            if (options.closeWindow)
                                window.close();
                        });
                        checklistPane.synChecklist("setInstance", data.checklistInstance);
                    },
                    fail(jqXHR, textStatus, errorThrown, url) {
                        Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                    }
                });
            }
        },
    },
    cestampupdateext: {
        // DocGen
        "19": {
            impl(ids, parentId, relId, completedHandler) {
                Utilities_1.synUtil.beginAjaxProgress();
                const guid = Utilities_1.synUtil.getGUID();
                const dataobj = {
                    "tempPathGUID": guid,
                    "tempPathTarget": "cestampupdateext_19_exportdir"
                };
                const contentTempDownloadableUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownloadable");
                const contentTempDownloadUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownload");
                Utilities_1.synUtil.executeMethod({
                    method: "cestampupdateext.19",
                    ids,
                    parentId,
                    relId,
                    done() {
                        Utilities_1.synUtil.beginAjaxProgress();
                        Utilities_1.synUtil.getAJAXData({
                            url: contentTempDownloadableUrl + guid + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken,
                            done(data) {
                                if (data.downloadable) {
                                    const contentUrl = contentTempDownloadUrl + guid + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken;
                                    if (data.webDisplayable)
                                        window.open(contentUrl, '_blank');
                                    else
                                        $.fileDownload(contentUrl);
                                }
                                if (completedHandler)
                                    completedHandler(true, data);
                            },
                            cleanUp: () => { Utilities_1.synUtil.endAjaxProgress(); }
                        });
                    },
                    cleanUp: () => { Utilities_1.synUtil.endAjaxProgress(); },
                    additionalData: dataobj
                });
            }
        }
    },
};
